import React from "react";
import { NavLink } from "react-router-dom";
import "../Css/All.css";

const Home = () => {
  return (
    <>
      <div className="mainSection">
        <div className="contentBox">
          <h1>Transform Your Business with Manognaa Solutions</h1>
          <h2>Your Partner in Digital Transformation</h2>
          <div className="btnBox">
            <div className="btn">
              <NavLink to="/about" className="readMore">
                Know more
              </NavLink>
            </div>
            <div className="btn" style={{ marginLeft: "1em" }}>
              <NavLink to="/pricing" className="readMore">
                See Pricing
              </NavLink>
            </div>
          </div>
        </div>
        <div className="imageContainerCenter">
          <div className="svgGraphic">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              zoomAndPan="magnify"
              viewBox="0 0 573 611.249981"
              preserveAspectRatio="xMidYMid meet"
              version="1.0"
            >
              <defs>
                <clipPath id="522e7633af">
                  <path
                    d="M 0.351562 0 L 572.648438 0 L 572.648438 610.5 L 0.351562 610.5 Z M 0.351562 0 "
                    clip-rule="nonzero"
                  />
                </clipPath>
                <clipPath id="f834248ced">
                  <path
                    d="M 249 606 L 319 606 L 319 610.238281 L 249 610.238281 Z M 249 606 "
                    clip-rule="nonzero"
                  />
                </clipPath>
                <clipPath id="ccb7ce51bf">
                  <path
                    d="M 360 606 L 430 606 L 430 610.238281 L 360 610.238281 Z M 360 606 "
                    clip-rule="nonzero"
                  />
                </clipPath>
                <clipPath id="f69e3b6387">
                  <path
                    d="M 0.558594 304.925781 L 54.492188 304.925781 L 54.492188 354.367188 L 0.558594 354.367188 Z M 0.558594 304.925781 "
                    clip-rule="nonzero"
                  />
                </clipPath>
              </defs>
              <g clip-path="url(#522e7633af)">
                <path
                  fill="#f0f8ff"
                  d="M 0.351562 0 L 572.648438 0 L 572.648438 617.992188 L 0.351562 617.992188 Z M 0.351562 0 "
                  fill-opacity="1"
                  fill-rule="nonzero"
                />
                <path
                  fill="#f0f8ff"
                  d="M 0.351562 0 L 572.648438 0 L 572.648438 610.5 L 0.351562 610.5 Z M 0.351562 0 "
                  fill-opacity="1"
                  fill-rule="nonzero"
                />
              </g>
              <path
                fill="#e6e6ff"
                d="M 113.671875 367.9375 C 182.566406 311.863281 283.144531 428.625 222.097656 482.519531 C 161.046875 536.410156 138.589844 564.226562 97.722656 519.777344 C 56.851562 475.332031 73.464844 400.664062 113.671875 367.9375 Z M 113.671875 367.9375 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                fill="#e6e6ff"
                d="M 36.652344 153 C 8.828125 289.496094 189.03125 216.824219 253.183594 315.578125 C 317.339844 414.332031 324.101562 580.84375 431.894531 539.980469 C 539.683594 499.117188 571.785156 214.230469 478.605469 128.710938 C 392.035156 49.257812 61.804688 29.621094 36.652344 153 Z M 36.652344 153 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                fill="#000048"
                d="M 280.449219 201.753906 L 255.21875 226.324219 L 177.371094 162.003906 L 190.589844 142.925781 L 250.808594 180.878906 L 280.898438 121.871094 Z M 280.449219 201.753906 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                fill="#ffb2a3"
                d="M 184.320312 128.652344 L 169.222656 121.871094 L 151.796875 127.273438 L 150.960938 130.828125 L 168.214844 127.363281 L 175.972656 132.457031 L 163.945312 133.652344 L 154.550781 144.003906 L 173.300781 153.074219 L 180.015625 158.230469 L 190.113281 143.21875 Z M 184.320312 128.652344 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                fill="#ff8099"
                d="M 156.152344 142.632812 L 240.039062 142.632812 C 240.359375 142.632812 240.667969 142.695312 240.964844 142.816406 C 241.261719 142.941406 241.523438 143.117188 241.75 143.34375 C 241.976562 143.570312 242.152344 143.832031 242.277344 144.128906 C 242.398438 144.425781 242.460938 144.734375 242.460938 145.054688 L 242.460938 145.601562 C 242.460938 145.921875 242.398438 146.230469 242.277344 146.527344 C 242.152344 146.824219 241.976562 147.085938 241.75 147.3125 C 241.523438 147.539062 241.261719 147.714844 240.964844 147.839844 C 240.667969 147.960938 240.359375 148.023438 240.039062 148.023438 L 156.152344 148.023438 C 155.828125 148.023438 155.519531 147.960938 155.222656 147.839844 C 154.925781 147.714844 154.664062 147.539062 154.4375 147.3125 C 154.210938 147.085938 154.035156 146.824219 153.914062 146.527344 C 153.789062 146.230469 153.726562 145.921875 153.726562 145.601562 L 153.726562 145.054688 C 153.726562 144.734375 153.789062 144.425781 153.914062 144.128906 C 154.035156 143.832031 154.210938 143.570312 154.4375 143.34375 C 154.664062 143.117188 154.925781 142.941406 155.222656 142.816406 C 155.519531 142.695312 155.828125 142.632812 156.152344 142.632812 Z M 156.152344 142.632812 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                fill="#ff355b"
                d="M 146.71875 145.777344 L 262.691406 145.777344 C 263.011719 145.777344 263.320312 145.839844 263.617188 145.960938 C 263.914062 146.085938 264.175781 146.261719 264.402344 146.488281 C 264.628906 146.714844 264.804688 146.976562 264.929688 147.273438 C 265.050781 147.570312 265.113281 147.878906 265.113281 148.199219 L 265.113281 148.742188 C 265.113281 149.0625 265.050781 149.375 264.929688 149.671875 C 264.804688 149.96875 264.628906 150.230469 264.402344 150.457031 C 264.175781 150.683594 263.914062 150.859375 263.617188 150.980469 C 263.320312 151.105469 263.011719 151.164062 262.691406 151.164062 L 146.71875 151.164062 C 146.398438 151.164062 146.085938 151.105469 145.789062 150.980469 C 145.492188 150.859375 145.230469 150.683594 145.003906 150.457031 C 144.777344 150.230469 144.601562 149.96875 144.480469 149.671875 C 144.355469 149.375 144.296875 149.0625 144.296875 148.742188 L 144.296875 148.199219 C 144.296875 147.878906 144.355469 147.570312 144.480469 147.273438 C 144.601562 146.976562 144.777344 146.714844 145.003906 146.488281 C 145.230469 146.261719 145.492188 146.085938 145.789062 145.960938 C 146.085938 145.839844 146.398438 145.777344 146.71875 145.777344 Z M 146.71875 145.777344 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                fill="#ff355b"
                d="M 87.941406 42.195312 L 145.929688 142.621094 C 146.089844 142.902344 146.191406 143.199219 146.230469 143.515625 C 146.273438 143.835938 146.253906 144.152344 146.171875 144.460938 C 146.085938 144.769531 145.949219 145.054688 145.753906 145.308594 C 145.558594 145.5625 145.320312 145.769531 145.042969 145.933594 L 142.714844 147.273438 C 142.4375 147.433594 142.140625 147.535156 141.820312 147.578125 C 141.503906 147.621094 141.1875 147.597656 140.878906 147.515625 C 140.566406 147.433594 140.285156 147.292969 140.03125 147.097656 C 139.773438 146.902344 139.566406 146.664062 139.40625 146.386719 L 81.421875 45.960938 C 81.257812 45.683594 81.160156 45.382812 81.117188 45.066406 C 81.074219 44.746094 81.09375 44.433594 81.179688 44.121094 C 81.261719 43.8125 81.402344 43.53125 81.597656 43.273438 C 81.792969 43.019531 82.027344 42.8125 82.308594 42.652344 L 84.632812 41.308594 C 84.910156 41.148438 85.210938 41.046875 85.527344 41.003906 C 85.847656 40.964844 86.160156 40.984375 86.472656 41.066406 C 86.78125 41.152344 87.0625 41.289062 87.320312 41.484375 C 87.574219 41.679688 87.78125 41.917969 87.941406 42.195312 Z M 87.941406 42.195312 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                fill="#ffbc6c"
                d="M 296.050781 110.839844 L 348.84375 110.839844 L 351.042969 326.234375 L 289.0625 323.246094 Z M 296.050781 110.839844 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                fill="#000048"
                d="M 348.652344 312.847656 L 311.804688 582.621094 L 288.902344 582.621094 L 284.113281 312.847656 Z M 348.652344 312.847656 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                fill="#010163"
                d="M 311.113281 312.847656 L 398.863281 582.621094 L 421.769531 582.621094 L 386.378906 312.847656 Z M 311.113281 312.847656 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                fill="#ffb2a3"
                d="M 336.75 70.890625 C 336.542969 70.84375 336.339844 70.78125 336.144531 70.703125 C 335.132812 75.890625 333.296875 83.269531 327.507812 89.292969 C 322.929688 94.058594 315.886719 97.976562 304.855469 99.296875 C 303.882812 98.996094 302.929688 98.640625 302 98.222656 C 285.425781 90.855469 282.769531 68.015625 282.578125 49.484375 C 282.542969 45.808594 282.601562 42.300781 282.671875 39.117188 C 319.113281 41.8125 334.609375 21.148438 331.691406 68.867188 C 338.652344 61.683594 335.058594 50.902344 338.988281 47.199219 C 352.074219 43.683594 345.953125 73.113281 336.75 70.890625 Z M 336.75 70.890625 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                fill="#ff8099"
                d="M 336.746094 70.890625 L 336.746094 106.707031 C 336.09375 107.730469 333.671875 110.019531 330.203125 112.15625 C 323.296875 116.425781 312.246094 120.152344 302.679688 112.382812 L 302.714844 98.515625 C 303.410156 98.832031 304.125 99.089844 304.859375 99.289062 C 315.894531 97.96875 322.933594 94.046875 327.511719 89.285156 C 327.554688 89.242188 327.59375 89.203125 327.632812 89.160156 L 327.871094 88.90625 C 327.949219 88.820312 328.027344 88.734375 328.105469 88.648438 C 328.179688 88.566406 328.257812 88.476562 328.332031 88.390625 C 328.636719 88.046875 328.929688 87.699219 329.207031 87.351562 C 329.308594 87.226562 329.410156 87.09375 329.503906 86.96875 C 329.679688 86.746094 329.847656 86.515625 330.011719 86.289062 C 330.136719 86.117188 330.257812 85.945312 330.375 85.773438 C 330.390625 85.753906 330.402344 85.734375 330.417969 85.710938 C 330.53125 85.546875 330.640625 85.378906 330.75 85.210938 C 330.859375 85.046875 330.988281 84.851562 331.097656 84.671875 C 331.183594 84.535156 331.265625 84.398438 331.347656 84.265625 L 331.433594 84.117188 C 331.539062 83.9375 331.636719 83.757812 331.746094 83.582031 C 331.851562 83.402344 331.945312 83.222656 332.042969 83.042969 C 332.042969 83.039062 332.042969 83.035156 332.042969 83.03125 C 332.144531 82.847656 332.246094 82.667969 332.332031 82.484375 C 332.417969 82.304688 332.519531 82.117188 332.609375 81.933594 C 332.730469 81.6875 332.84375 81.445312 332.960938 81.199219 L 333.125 80.835938 C 333.207031 80.652344 333.285156 80.472656 333.363281 80.289062 C 333.441406 80.109375 333.535156 79.886719 333.617188 79.683594 C 333.699219 79.480469 333.78125 79.28125 333.855469 79.078125 C 333.949219 78.84375 334.035156 78.609375 334.117188 78.375 C 334.179688 78.207031 334.238281 78.039062 334.292969 77.875 C 334.351562 77.710938 334.421875 77.5 334.480469 77.316406 C 334.679688 76.710938 334.863281 76.113281 335.027344 75.523438 C 335.078125 75.339844 335.125 75.160156 335.171875 74.984375 C 335.21875 74.8125 335.265625 74.644531 335.304688 74.476562 C 335.347656 74.308594 335.386719 74.160156 335.425781 74 C 335.601562 73.285156 335.757812 72.585938 335.894531 71.933594 C 335.9375 71.730469 335.976562 71.53125 336.019531 71.328125 C 336.058594 71.125 336.101562 70.910156 336.140625 70.707031 C 336.339844 70.785156 336.539062 70.84375 336.746094 70.890625 Z M 336.746094 70.890625 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                fill="#000048"
                d="M 338.996094 47.199219 C 335.066406 50.90625 338.65625 61.683594 331.695312 68.867188 C 334.617188 21.152344 319.121094 41.816406 282.675781 39.117188 C 282.609375 42.300781 282.550781 45.808594 282.582031 49.484375 C 267.542969 33.261719 272.875 0.484375 297.222656 4.984375 C 323.949219 9.925781 353.945312 21.398438 354.265625 42.484375 C 354.582031 63.367188 340.117188 84.25 336.75 93.835938 L 336.75 70.890625 C 345.953125 73.113281 352.074219 43.683594 338.996094 47.199219 Z M 338.996094 47.199219 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                fill="#7473ff"
                d="M 249.636719 606.535156 L 318.691406 606.535156 L 311.617188 582.621094 L 288.710938 582.621094 Z M 249.636719 606.535156 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <g clip-path="url(#f834248ced)">
                <path
                  fill="#fea531"
                  d="M 249.636719 606.535156 L 318.6875 606.535156 L 318.6875 610.238281 L 249.636719 610.238281 Z M 249.636719 606.535156 "
                  fill-opacity="1"
                  fill-rule="nonzero"
                />
              </g>
              <path
                fill="#7473ff"
                d="M 360.042969 606.535156 L 429.09375 606.535156 L 422.019531 582.621094 L 399.113281 582.621094 Z M 360.042969 606.535156 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <g clip-path="url(#ccb7ce51bf)">
                <path
                  fill="#fea531"
                  d="M 360.042969 606.535156 L 429.09375 606.535156 L 429.09375 610.238281 L 360.042969 610.238281 Z M 360.042969 606.535156 "
                  fill-opacity="1"
                  fill-rule="nonzero"
                />
              </g>
              <path
                fill="#7473ff"
                d="M 392.191406 333.058594 L 330.203125 333.058594 L 330.203125 112.171875 C 333.675781 110.027344 334.453125 107.433594 335.105469 106.40625 L 336.75 99.351562 L 375.964844 113.738281 C 377.050781 114.136719 378.101562 114.613281 379.113281 115.171875 C 380.128906 115.730469 381.09375 116.359375 382.007812 117.066406 C 382.925781 117.769531 383.785156 118.539062 384.585938 119.371094 C 385.386719 120.207031 386.117188 121.097656 386.785156 122.042969 C 387.449219 122.988281 388.039062 123.980469 388.550781 125.015625 C 389.066406 126.050781 389.5 127.117188 389.851562 128.21875 C 390.207031 129.320312 390.472656 130.441406 390.652344 131.582031 C 390.835938 132.726562 390.929688 133.875 390.9375 135.03125 Z M 392.191406 333.058594 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                fill="#7473ff"
                d="M 302.683594 333.058594 L 280.449219 333.058594 L 280.933594 121.886719 L 302.683594 104.019531 Z M 302.683594 333.058594 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                fill="#010163"
                d="M 384.363281 168.230469 L 314.90625 239.859375 L 229.78125 178.890625 L 243.632812 159.085938 L 311.804688 193.554688 L 357.636719 112.609375 C 357.636719 112.609375 402.996094 105.808594 384.363281 168.230469 Z M 384.363281 168.230469 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                fill="#ffb2a3"
                d="M 239.617188 147.894531 L 237.222656 130.859375 L 227.335938 124.121094 L 225.996094 127.519531 L 231.054688 136.222656 L 227.3125 151.066406 L 193.476562 151.339844 L 208.1875 161.28125 L 225.777344 169.792969 L 232.496094 174.949219 L 242.59375 159.9375 Z M 239.617188 147.894531 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                fill="#010163"
                d="M 330.203125 215 L 347.183594 158.207031 L 330.203125 112.609375 Z M 330.203125 215 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                fill="#010163"
                d="M 302.683594 215 L 285.699219 158.207031 L 302.683594 112.609375 Z M 302.683594 215 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <g clip-path="url(#f69e3b6387)">
                <path
                  fill="#e6e6ff"
                  d="M 30.101562 304.925781 C 42.25 304.925781 54.492188 312.175781 54.492188 324.480469 C 54.492188 339.625 45.046875 354.359375 30.101562 354.359375 C 13.796875 354.359375 0.558594 340.996094 0.558594 324.480469 C 0.558594 310.519531 16.320312 304.925781 30.101562 304.925781 Z M 30.101562 304.925781 "
                  fill-opacity="1"
                  fill-rule="evenodd"
                />
              </g>
            </svg>
          </div>
        </div>
      </div>

      <div className="mainSection">
        <div className="contentBox">
          <h1>Experience excellence with us</h1>
          <h2>Your partner in business</h2>
          <p>
            We are all along the way building your business. Experience the
            power of digital transformation with Manognaa Solutions. We provide
            customised solutions to meet your business requirements, ensuring
            your satisfaction and customer satisfaction every step of the way.
          </p>
          <div className="btnBox">
            <div className="btn">
              <NavLink to="/about" className="readMore">
                Know more
              </NavLink>
            </div>
          </div>
        </div>
        <div className="imageContainerCenter">
          <div className="svgGraphic">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              zoomAndPan="magnify"
              viewBox="0 0 519 519.000007"
              preserveAspectRatio="xMidYMid meet"
              version="1.0"
            >
              <path
                fill="#ccf3e5"
                d="M 479.859375 285.460938 C 479.859375 314.726562 464.191406 341.167969 438.976562 360.046875 C 425.214844 370.351562 412.839844 382.367188 401.648438 395.421875 C 377.566406 423.507812 336.28125 442.027344 289.394531 442.027344 C 232.53125 442.027344 183.910156 414.789062 164.214844 376.285156 C 155.125 358.511719 140.589844 344.046875 122.542969 335.507812 C 82.332031 316.476562 55.300781 281.027344 55.300781 240.433594 C 55.300781 179.738281 115.738281 130.53125 190.296875 130.53125 C 231.632812 130.53125 268.628906 145.65625 293.390625 169.480469 C 303.136719 178.851562 316.511719 183.417969 329.980469 182.234375 C 335.015625 181.792969 340.132812 181.566406 345.320312 181.566406 C 419.621094 181.566406 479.859375 228.082031 479.859375 285.460938 Z M 479.859375 285.460938 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                fill="#d4d4d4"
                d="M 197.605469 236.460938 C 183.660156 241.953125 174.167969 267.445312 174.328125 290.105469 C 174.328125 290.105469 198.992188 433.972656 198.992188 433.972656 C 198.992188 433.972656 222.296875 433.808594 222.296875 433.808594 C 214.546875 353.824219 206.976562 268.648438 197.605469 236.460938 Z M 197.605469 236.460938 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 198.232051, 335.217157)"
                fill="none"
                stroke-linejoin="round"
                d="M -1.308273 -206.198224 C -30.425413 -194.730801 -50.244642 -141.504343 -49.910244 -94.191029 C -49.910244 -94.191029 1.587129 206.19672 1.587129 206.19672 C 1.587129 206.19672 50.246193 205.862322 50.246193 205.862322 C 34.064567 38.850648 18.258119 -138.992276 -1.308273 -206.198224 Z M -1.308273 -206.198224 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 132.991082, 299.07501)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 135.923076 -130.735165 C 110.48432 -146.370335 85.583864 -159.982801 61.760008 -169.590642 C 61.760008 -169.590642 -50.108533 -178.700963 -50.108533 -178.700963 C -79.780286 -167.42113 -108.611963 -153.718946 -135.918458 -135.669582 C -135.918458 -135.669582 -78.719997 168.062153 -78.719997 168.062153 C -3.659762 178.053328 56.442256 178.697657 94.408723 165.525618 C 94.408723 165.525618 135.923076 -130.735165 135.923076 -130.735165 Z M 135.923076 -130.735165 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="butt"
                transform="matrix(0.478938, 0, 0, 0.478938, 133.856515, 208.927803)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="miter"
                d="M -37.675033 -57.488143 C -37.675033 -57.488143 -34.07821 -5.534031 -34.07821 -5.534031 C -34.07821 -5.534031 17.557817 57.487857 17.557817 57.487857 C 17.557817 57.487857 37.678821 19.896569 37.678821 19.896569 C 37.678821 19.896569 37.678821 -30.214273 37.678821 -30.214273 C 37.678821 -30.214273 -37.675033 -57.488143 -37.675033 -57.488143 Z M -37.675033 -57.488143 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="10"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 133.856515, 195.87243)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 36.112857 2.99864 C 36.112857 2.99864 36.112857 20.754387 36.112857 20.754387 C -2.449003 21.496588 -21.680996 5.045812 -36.117225 -21.502169 C -11.681664 -4.18685 10.649632 3.406443 36.112857 2.99864 Z M 36.112857 2.99864 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 122.111513, 220.519086)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 42.080814 33.285818 C 42.080814 33.285818 15.377868 18.47441 15.377868 18.47441 C 15.377868 18.47441 0.444119 39.737263 0.444119 39.737263 C 0.444119 39.737263 -42.081586 -17.208359 -42.081586 -17.208359 C -42.081586 -17.208359 -21.071572 -39.735402 -21.071572 -39.735402 C -21.071572 -39.735402 -10.248478 -39.735402 -10.248478 -39.735402 C -10.248478 -39.735402 -9.555213 -29.73607 -9.555213 -29.73607 C -9.555213 -29.73607 42.080814 33.285818 42.080814 33.285818 Z M 42.080814 33.285818 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 152.417293, 225.246667)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -21.196194 23.414857 C -21.196194 23.414857 -2.641154 11.64566 -2.641154 11.64566 C -2.641154 11.64566 17.903966 32.39468 17.903966 32.39468 C 17.903966 32.39468 21.199015 -15.440621 21.199015 -15.440621 C 21.199015 -15.440621 -1.07519 -32.397073 -1.07519 -32.397073 C -1.07519 -32.397073 -1.07519 -14.176432 -1.07519 -14.176432 C -1.07519 -14.176432 -21.196194 23.414857 -21.196194 23.414857 Z M -21.196194 23.414857 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 140.587042, 239.823643)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 17.52507 -15.911274 C 19.091033 -1.850224 17.557694 10.000534 12.80271 19.551282 C 12.80271 19.551282 -9.593835 19.551282 -9.593835 19.551282 C -16.061592 9.617199 -18.42685 -4.166545 -19.095647 -19.557033 C -19.095647 -19.557033 3.5048 -7.021167 3.5048 -7.021167 C 3.5048 -7.021167 17.52507 -15.911274 17.52507 -15.911274 Z M 17.52507 -15.911274 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 142.446769, 310.732362)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 8.919691 -128.502705 C 8.919691 -128.502705 25.819051 -22.955111 25.819051 -22.955111 C 21.153784 24.480543 12.108711 75.953448 1.897322 128.502953 C -9.733222 80.610559 -20.344258 30.597589 -25.816975 -30.16507 C -25.816975 -30.16507 -13.476854 -128.502705 -13.476854 -128.502705 C -13.476854 -128.502705 8.919691 -128.502705 8.919691 -128.502705 Z M 8.919691 -128.502705 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 136.324971, 389.47174)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 87.447723 -23.218395 C 87.447723 -23.218395 87.447723 7.032438 87.447723 7.032438 C 34.294669 23.214064 -24.641032 21.223985 -87.450862 7.032438 C -87.450862 7.032438 -85.680997 -20.68186 -85.680997 -20.68186 C -18.466893 -10.437846 40.25675 -10.095292 87.447723 -23.218395 Z M 87.447723 -23.218395 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 135.718624, 419.477702)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 88.713744 -55.618563 C 88.713744 -55.618563 97.571227 55.621961 97.571227 55.621961 C 97.571227 55.621961 -97.570703 55.621961 -97.570703 55.621961 C -97.570703 55.621961 -86.184841 -55.618563 -86.184841 -55.618563 C -86.184841 -55.618563 88.713744 -55.618563 88.713744 -55.618563 Z M 88.713744 -55.618563 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 57.858116, 309.074775)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 58.196129 -23.042036 C 58.196129 -23.042036 13.680345 115.668104 13.680345 115.668104 C -0.176804 156.024296 -65.743383 133.521722 -51.886235 93.157373 C -30.370544 -0.0664109 -5.559805 -82.051142 21.591724 -156.026621 C 52.919157 -128.467289 65.748642 -84.68555 58.196129 -23.042036 Z M 58.196129 -23.042036 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                fill="#231f1f"
                d="M 116.164062 183.492188 C 116.164062 183.492188 117.957031 187.324219 117.957031 187.324219 C 117.957031 187.324219 130.292969 195.824219 130.292969 195.824219 C 130.292969 195.824219 151.964844 199.898438 151.964844 199.898438 C 151.964844 199.898438 152.203125 189.839844 152.203125 189.839844 C 152.203125 189.839844 116.164062 183.492188 116.164062 183.492188 Z M 116.164062 183.492188 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 175.746387, 135.081288)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 6.883105 -30.575523 C 13.301925 -10.462675 9.19127 9.943791 -3.369065 30.570471 C -3.369065 30.570471 -13.303148 -27.451751 -13.303148 -27.451751 C -13.303148 -27.451751 6.883105 -30.575523 6.883105 -30.575523 Z M 6.883105 -30.575523 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="butt"
                transform="matrix(0.478938, 0, 0, 0.478938, 144.212136, 151.777559)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="miter"
                d="M -62.535027 -13.400859 C -62.535027 -13.400859 -61.964102 24.378019 -61.964102 24.378019 C -61.964102 24.378019 -58.734302 69.75019 -58.734302 69.75019 C -28.744463 90.825453 2.982616 101.477269 37.857936 93.272271 C 45.320732 91.510562 51.315438 85.948128 53.664383 78.648453 C 64.022582 46.47279 65.197054 1.875445 57.44064 -54.784715 C 30.672446 -101.478168 -28.556874 -98.631703 -65.193903 -60.094311 C -65.193903 -60.094311 -62.535027 -13.400859 -62.535027 -13.400859 Z M -62.535027 -13.400859 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="10"
              />
              <path
                stroke-linecap="butt"
                transform="matrix(0.478938, 0, 0, 0.478938, 107.786005, 151.847487)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="miter"
                d="M 13.520979 -13.546866 C 6.180524 -25.691242 -14.193318 -17.722769 -7.994712 2.651072 C -1.388302 19.680929 6.286552 24.060734 14.197932 25.691947 C 14.197932 25.691947 13.520979 -13.546866 13.520979 -13.546866 Z M 13.520979 -13.546866 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="10"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 113.937481, 132.149718)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 17.935218 -35.318421 C 32.746626 -12.489604 20.797996 32.515544 1.353945 44.301053 C 1.353945 44.301053 0.676992 27.581127 0.676992 27.581127 C -4.249269 22.450964 -9.558865 19.376129 -16.352865 24.277922 C -30.83803 -3.607653 -32.746549 -26.852429 -18.938336 -44.298245 C -18.938336 -44.298245 17.935218 -35.318421 17.935218 -35.318421 Z M 17.935218 -35.318421 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 146.537855, 107.537552)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 64.729025 -37.204798 C 87.00323 -3.683385 75.486871 21.959273 53.579689 45.17958 C 35.040961 25.36035 2.261749 22.905376 -43.501912 36.256849 C -43.501912 36.256849 -87.006345 7.090772 -87.006345 7.090772 C -83.148528 -32.270381 -39.676719 -45.181427 -6.220555 -25.623191 C 29.92711 -10.591569 54.060897 -13.723497 64.729025 -37.204798 Z M 64.729025 -37.204798 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 160.53913, 157.254692)"
                fill="none"
                stroke-linejoin="round"
                d="M -2.846606 -28.629417 C -1.827098 -7.513373 2.73214 10.389182 10.822954 25.094561 C 3.025759 27.89209 -4.143419 28.634292 -10.823234 27.745281 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 140.052553, 142.89949)"
                fill="none"
                stroke-linejoin="round"
                d="M 10.444216 -3.672426 C 1.203398 -5.058956 -5.761879 -2.155398 -10.443458 5.062716 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 167.252406, 142.330031)"
                fill="none"
                stroke-linejoin="round"
                d="M 8.257068 2.809862 C 4.056696 -0.819585 -1.032687 -2.809664 -8.258957 -0.860365 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 143.022442, 152.48208)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -4.239073 -0.00336406 C -4.239073 4.645591 -2.338711 8.413692 0.00207904 8.413692 C 2.342869 8.413692 4.235075 4.645591 4.235075 -0.00336406 C 4.235075 -4.644163 2.342869 -8.412264 0.00207904 -8.412264 C -2.338711 -8.412264 -4.239073 -4.644163 -4.239073 -0.00336406 Z M -4.239073 -0.00336406 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 167.252406, 150.090746)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -3.349008 -0.0018838 C -3.349008 3.774373 -1.856449 6.841052 0.00313324 6.841052 C 1.854559 6.841052 3.355275 3.774373 3.355275 -0.0018838 C 3.355275 -3.77814 1.854559 -6.836663 0.00313324 -6.836663 C -1.856449 -6.836663 -3.349008 -3.77814 -3.349008 -0.0018838 Z M -3.349008 -0.0018838 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 145.35632, 179.727459)"
                fill="none"
                stroke-linejoin="round"
                d="M 15.380555 7.591421 C 3.611358 5.054886 -6.991522 0.569052 -15.375954 -7.595166 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 363.475644, 199.673101)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 24.519304 -102.356496 C -28.994347 -140.281208 -96.741388 -77.528867 -87.168086 -12.953714 C -101.10642 22.140296 -94.621016 59.247298 -77.842174 97.377069 C -31.944229 122.475916 74.06043 140.279127 101.106802 56.348534 C 95.302256 10.302164 89.33536 -34.121073 81.712301 -62.41083 C 75.508399 -90.693105 53.449729 -100.526983 24.519304 -102.356496 Z M 24.519304 -102.356496 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 363.475644, 199.673101)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 24.519304 -102.356496 C -28.994347 -140.281208 -96.741388 -77.528867 -87.168086 -12.953714 C -101.10642 22.140296 -94.621016 59.247298 -77.842174 97.377069 C -31.944229 122.475916 74.06043 140.279127 101.106802 56.348534 C 95.302256 10.302164 89.33536 -34.121073 81.712301 -62.41083 C 75.508399 -90.693105 53.449729 -100.526983 24.519304 -102.356496 Z M 24.519304 -102.356496 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="butt"
                transform="matrix(0.478938, 0, 0, 0.478938, 311.882184, 346.74901)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="miter"
                d="M 4.707359 51.173198 C -6.360416 85.216599 -44.424756 72.843853 -33.35698 38.800452 C -33.35698 38.800452 3.989626 -85.212465 3.989626 -85.212465 C 3.989626 -85.212465 44.427379 -55.826175 44.427379 -55.826175 C 44.427379 -55.826175 4.707359 51.173198 4.707359 51.173198 Z M 4.707359 51.173198 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="10"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 323.516057, 297.569708)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 12.730711 -63.999352 C -10.008389 -40.542519 -27.372644 -7.787776 -40.454967 32.380828 C -40.454967 32.380828 20.33216 64.001879 20.33216 64.001879 C 20.33216 64.001879 33.577604 14.510897 33.577604 14.510897 C 40.453164 -25.249904 38.870888 -56.699677 12.730711 -63.999352 Z M 12.730711 -63.999352 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                fill="#231f1f"
                d="M 337.515625 375.890625 C 337.515625 375.890625 400.8125 374.644531 400.8125 374.644531 C 416.457031 427.273438 406.160156 441.164062 406.054688 452.441406 C 381.929688 459.121094 357.632812 458.929688 333.398438 451.25 C 317.675781 410.269531 332.644531 390.875 337.515625 375.890625 Z M 337.515625 375.890625 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 369.718294, 465.674681)"
                fill="none"
                stroke-linejoin="round"
                d="M -67.23762 -187.464779 C -67.23762 -187.464779 64.923203 -190.066563 64.923203 -190.066563 C 102.090376 -67.179183 71.089186 -49.178755 75.6158 -26.880082 C 25.243963 -12.933217 -25.233902 -14.083221 -75.834108 -30.118039 C -90.408991 -66.681663 -103.907273 -98.180373 -67.23762 -187.464779 Z M -67.23762 -187.464779 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 372.636002, 318.517041)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -89.919082 -107.401976 C -71.527163 -118.575781 -52.37673 -125.924392 -32.011044 -127.204894 C -32.011044 -127.204894 -15.103529 -110.623621 -15.103529 -110.623621 C -15.103529 -110.623621 28.710834 -138.337918 28.710834 -138.337918 C 28.710834 -138.337918 101.69943 -107.401976 101.69943 -107.401976 C 76.692945 -32.031811 62.012034 42.848991 58.83117 117.191492 C 14.772125 138.34016 -29.278764 137.255404 -73.329653 119.793276 C -69.382119 77.365444 -67.93034 39.80678 -76.184274 21.227271 C -98.695004 4.939616 -101.696435 -26.118666 -84.935728 -72.135166 C -84.185371 -81.588041 -86.501692 -93.977099 -89.919082 -107.401976 Z M -89.919082 -107.401976 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 371.845278, 242.250448)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -30.360052 -19.192148 C -30.360052 -19.192148 -30.360052 32.036075 -30.360052 32.036075 C -30.360052 32.036075 -13.452536 48.617349 -13.452536 48.617349 C -13.452536 48.617349 30.361827 20.903051 30.361827 20.903051 C 30.361827 20.903051 29.945868 -48.619218 29.945868 -48.619218 C 29.945868 -48.619218 -30.360052 -19.192148 -30.360052 -19.192148 Z M -30.360052 -19.192148 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 371.476966, 232.388623)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -29.591034 5.61555 C -29.591034 5.61555 -29.591034 22.930869 -29.591034 22.930869 C -4.568237 23.338672 18.309516 4.954909 29.589349 -23.338469 C 12.486088 -7.882732 -10.391665 4.726539 -29.591034 5.61555 Z M -29.591034 5.61555 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 354.851558, 222.291165)"
                fill="none"
                stroke-linejoin="round"
                d="M -13.808202 -0.787371 C -2.699646 6.349183 6.508547 4.497757 13.808223 -6.349805 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 371.845278, 242.250448)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -30.360052 -19.192148 C -30.360052 -19.192148 -30.360052 32.036075 -30.360052 32.036075 C -30.360052 32.036075 -13.452536 48.617349 -13.452536 48.617349 C -13.452536 48.617349 30.361827 20.903051 30.361827 20.903051 C 30.361827 20.903051 29.945868 -48.619218 29.945868 -48.619218 C 29.945868 -48.619218 -30.360052 -19.192148 -30.360052 -19.192148 Z M -30.360052 -19.192148 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 371.476966, 232.388623)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -29.591034 5.61555 C -29.591034 5.61555 -29.591034 22.930869 -29.591034 22.930869 C -4.568237 23.338672 18.309516 4.954909 29.589349 -23.338469 C 12.486088 -7.882732 -10.391665 4.726539 -29.591034 5.61555 Z M -29.591034 5.61555 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 356.554204, 262.409427)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 1.566973 -17.354576 C -14.076353 -10.911287 -18.47247 -3.562676 -15.112173 4.723883 C -13.056845 9.796953 -8.693352 13.556898 -3.579502 14.967896 C 5.057767 17.357622 12.112761 13.352996 18.474489 6.526372 C 18.474489 6.526372 1.566973 -10.054901 1.566973 -10.054901 C 1.566973 -10.054901 1.566973 -17.354576 1.566973 -17.354576 Z M 1.566973 -17.354576 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 380.022658, 261.475981)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -30.526512 8.475361 C -30.526512 8.475361 13.287851 -19.238936 13.287851 -19.238936 C 13.287851 -19.238936 13.287851 -24.874774 13.287851 -24.874774 C 30.529765 -10.569042 29.950685 3.092361 12.513025 16.150215 C -7.395921 24.869045 -20.820799 20.440304 -30.526512 8.475361 Z M -30.526512 8.475361 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 361.447024, 330.524519)"
                fill="none"
                stroke-linejoin="round"
                d="M -42.790272 -3.338088 C -30.809018 0.699162 -17.914284 -2.522482 -5.712816 -5.703346 C -3.567772 -6.266114 -1.365635 -6.828883 0.828345 -6.543421 C 3.911336 -6.15193 6.586525 -4.153694 9.302493 -2.50617 C 19.440478 3.6435 31.274923 5.291025 42.791282 6.824364 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="butt"
                transform="matrix(0.478938, 0, 0, 0.478938, 422.832087, 348.931086)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="miter"
                d="M -12.715417 49.12104 C -8.311144 84.648845 31.408876 79.722583 27.004603 44.194779 C 27.004603 44.194779 13.873344 -84.646527 13.873344 -84.646527 C 13.873344 -84.646527 -31.40911 -63.465234 -31.40911 -63.465234 C -31.40911 -63.465234 -12.715417 49.12104 -12.715417 49.12104 Z M -12.715417 49.12104 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="10"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 421.000097, 296.826908)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 0.717531 -62.114025 C 18.595618 -34.774907 29.426868 0.687649 34.646747 42.609806 C 34.646747 42.609806 -31.034017 62.119106 -31.034017 62.119106 C -31.034017 62.119106 -34.647153 11.013223 -34.647153 11.013223 C -33.856015 -29.334813 -26.32797 -59.903732 0.717531 -62.114025 Z M 0.717531 -62.114025 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                fill="#231f1f"
                d="M 386.285156 216.539062 C 386.285156 216.539062 357.070312 226.359375 357.070312 226.359375 C 357.070312 226.359375 357.667969 235.21875 357.667969 235.21875 C 357.667969 235.21875 356.46875 239.648438 357.667969 238.929688 C 358.863281 238.210938 379.816406 229.230469 384.609375 223.605469 C 389.398438 217.976562 386.285156 216.539062 386.285156 216.539062 Z M 386.285156 216.539062 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 354.805358, 199.809772)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -50.008225 -38.516075 C -67.864448 76.068787 7.884905 101.62649 65.365765 43.715577 C 65.365765 43.715577 67.869045 -9.063496 67.869045 -9.063496 C 67.869045 -9.063496 67.868644 -44.207971 67.868644 -44.207971 C 44.767839 -101.623824 -37.145068 -87.768499 -50.008225 -38.516075 Z M -50.008225 -38.516075 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 392.570998, 202.004507)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -10.985963 -13.608498 C 2.704037 -22.081002 10.70582 -20.641184 12.179996 -7.845022 C 12.646808 -3.816149 12.216484 0.278399 11.215154 4.201941 C 6.819022 21.323608 -2.674272 22.086636 -12.641343 21.324706 C -12.641343 21.324706 -10.985963 -13.608498 -10.985963 -13.608498 Z M -10.985963 -13.608498 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 347.876639, 200.601034)"
                fill="none"
                stroke-linejoin="round"
                d="M 1.787995 -23.285307 C 0.533409 -3.090298 -2.583854 10.597057 -7.147148 19.220186 C -4.356045 22.856463 1.067941 23.286155 7.144039 22.932554 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 365.024955, 187.66492)"
                fill="none"
                stroke-linejoin="round"
                d="M -11.145748 -2.94083 C -1.921623 -3.74451 5.159184 -0.917724 11.147951 3.744696 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 340.483754, 187.460235)"
                fill="none"
                stroke-linejoin="round"
                d="M -8.300222 2.843724 C -2.764285 -1.424529 2.773005 -2.846318 8.303493 -1.421637 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 362.104964, 198.553642)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 3.57341 0.000484546 C 3.575295 3.96433 1.970079 7.178582 -0.00368809 7.179521 C -1.969299 7.180456 -3.569415 3.967728 -3.5713 0.00388221 C -3.573185 -3.959963 -1.976125 -7.174212 -0.00235838 -7.17515 C 1.971408 -7.176089 3.571525 -3.963361 3.57341 0.000484546 Z M 3.57341 0.000484546 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 364.669008, 195.942711)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -5.353365 -1.721107 C -1.258933 -1.535465 2.272296 -2.263034 5.346425 -3.748899 C 4.573135 -0.51873 1.6625 1.750039 -1.884436 3.749961 C -1.884436 3.749961 -5.353365 -1.721107 -5.353365 -1.721107 Z M -5.353365 -1.721107 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 340.54279, 198.354688)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -3.571981 0.00332861 C -3.570096 3.967174 -1.96998 7.179902 0.00378657 7.178963 C 1.969397 7.178029 3.574613 3.963777 3.572728 -0.0000690548 C 3.570843 -3.963915 1.970727 -7.176643 -0.00303978 -7.175704 C -1.976807 -7.174765 -3.573866 -3.960517 -3.571981 0.00332861 Z M -3.571981 0.00332861 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 337.9817, 195.741331)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 5.346987 -1.721683 C 1.260886 -1.540307 -2.27919 -2.264513 -5.354731 -3.747454 C -4.578369 -0.518022 -1.657417 1.756131 1.883264 3.752682 C 1.883264 3.752682 5.346987 -1.721683 5.346987 -1.721683 Z M 5.346987 -1.721683 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 359.266644, 171.608651)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 16.653801 -14.524199 C 16.522782 18.679195 32.23349 40.309759 58.576004 54.162538 C 58.576004 54.162538 66.079543 -14.523235 66.079543 -14.523235 C -3.347402 -54.161309 -35.445996 -29.294521 -66.083453 -1.900049 C -66.083453 -1.900049 -59.295174 20.370931 -59.295174 20.370931 C -31.508874 17.413378 -5.536249 8.086803 16.653801 -14.524199 Z M 16.653801 -14.524199 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 354.805358, 199.809772)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -50.008225 -38.516075 C -67.864448 76.068787 7.884905 101.62649 65.365765 43.715577 C 65.365765 43.715577 67.869045 -9.063496 67.869045 -9.063496 C 67.869045 -9.063496 67.868644 -44.207971 67.868644 -44.207971 C 44.767839 -101.623824 -37.145068 -87.768499 -50.008225 -38.516075 Z M -50.008225 -38.516075 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 392.570998, 202.004507)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -10.985963 -13.608498 C 2.704037 -22.081002 10.70582 -20.641184 12.179996 -7.845022 C 12.646808 -3.816149 12.216484 0.278399 11.215154 4.201941 C 6.819022 21.323608 -2.674272 22.086636 -12.641343 21.324706 C -12.641343 21.324706 -10.985963 -13.608498 -10.985963 -13.608498 Z M -10.985963 -13.608498 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 347.876639, 200.601034)"
                fill="none"
                stroke-linejoin="round"
                d="M 1.787995 -23.285307 C 0.533409 -3.090298 -2.583854 10.597057 -7.147148 19.220186 C -4.356045 22.856463 1.067941 23.286155 7.144039 22.932554 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 359.266644, 171.608651)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 16.653801 -14.524199 C 16.522782 18.679195 32.23349 40.309759 58.576004 54.162538 C 58.576004 54.162538 66.079543 -14.523235 66.079543 -14.523235 C -3.347402 -54.161309 -35.445996 -29.294521 -66.083453 -1.900049 C -66.083453 -1.900049 -59.295174 20.370931 -59.295174 20.370931 C -31.508874 17.413378 -5.536249 8.086803 16.653801 -14.524199 Z M 16.653801 -14.524199 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 366.14548, 186.032274)"
                fill="none"
                stroke-linejoin="round"
                d="M -11.144561 -2.941178 C -1.920436 -3.744858 5.160371 -0.918072 11.140982 3.744352 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 338.838477, 184.816205)"
                fill="none"
                stroke-linejoin="round"
                d="M -8.306822 2.842681 C -2.762729 -1.425576 2.774562 -2.847364 8.30505 -1.422683 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 362.106543, 196.237966)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 3.570113 -0.00103917 C 3.571998 3.962806 1.974938 7.177055 0.00117129 7.177993 C -1.972595 7.178932 -3.572712 3.966204 -3.574597 0.00235849 C -3.568326 -3.961491 -1.971266 -7.175739 0.002501 -7.176678 C 1.976268 -7.177617 3.568228 -3.964885 3.570113 -0.00103917 Z M 3.570113 -0.00103917 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 364.670119, 193.627049)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -5.34753 -1.722665 C -1.261254 -1.537019 2.278131 -2.264592 5.35226 -3.750457 C 4.570814 -0.520285 1.660182 1.756641 -1.878602 3.748403 C -1.878602 3.748403 -5.34753 -1.722665 -5.34753 -1.722665 Z M -5.34753 -1.722665 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 340.544661, 195.408734)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -3.575891 -0.00348596 C -3.574006 3.96036 -1.97389 7.173088 -0.00011892 7.180305 C 1.973648 7.179366 3.570708 3.965118 3.568823 0.00127244 C 3.575094 -3.962577 1.974978 -7.175305 0.00121079 -7.174366 C -1.972556 -7.173428 -3.56962 -3.967335 -3.575891 -0.00348596 Z M -3.575891 -0.00348596 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 337.983104, 192.795391)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 5.352213 -1.720376 C 1.257956 -1.538996 -2.273964 -2.263206 -5.349505 -3.746146 C -4.573143 -0.516715 -1.660347 1.757442 1.880334 3.753993 C 1.880334 3.753993 5.352213 -1.720376 5.352213 -1.720376 Z M 5.352213 -1.720376 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000227759, -0.000227759, 0.478938, 360.784872, 218.944762)"
                fill-opacity="1"
                fill="#231f1f"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 17.459012 -7.80435 C 18.349512 -4.672845 12.775583 5.459636 3.136419 8.196501 C -6.510906 10.925214 -16.570037 5.237065 -17.460537 2.105561 C -18.351033 -1.017788 -9.909525 -1.054427 -0.27036 -3.791292 C 9.37696 -6.52816 16.576672 -10.927702 17.459012 -7.80435 Z M 17.459012 -7.80435 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 259.12571, 61.486152)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 71.494553 -5.835294 C 71.494553 14.579328 62.938844 32.987559 49.236661 46.01279 C 39.245485 56.354676 31.285169 66.745498 30.184101 77.32391 C 30.184101 77.32391 -30.24416 77.32391 -30.24416 77.32391 C -31.394164 66.296915 -39.982497 55.481977 -50.560909 44.715976 C -50.60169 44.675196 -50.64247 44.634415 -50.691406 44.593635 C -63.545359 31.666277 -71.497519 13.845283 -71.497519 -5.835294 C -71.497519 -45.326944 -39.484978 -77.323174 -0.00148322 -77.323174 C 39.482011 -77.323174 71.494553 -45.326944 71.494553 -5.835294 Z M 71.494553 -5.835294 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 259.172641, 76.318874)"
                fill="none"
                stroke-linejoin="round"
                d="M -10.196676 48.996467 C -8.516527 26.738574 -8.141348 4.382809 -9.062983 -17.899551 C -9.454474 -27.311646 -10.115115 -36.895018 -13.312291 -45.622004 C -14.470452 -48.786556 -16.811242 -52.301819 -19.902389 -51.690114 C -21.868 -51.306779 -23.295311 -49.186203 -23.539993 -47.016691 C -23.776518 -44.847178 -23.034317 -42.685822 -21.990341 -40.834396 C -19.209124 -35.908135 -14.380735 -32.751739 -9.372914 -30.826909 C -4.193815 -28.83683 1.433868 -27.964131 6.873961 -28.983639 C 12.32221 -29.99499 17.558402 -33.004577 20.983948 -37.767717 C 22.558068 -39.969854 23.773321 -42.734759 23.349206 -45.467039 C 22.916934 -48.207476 20.282526 -50.564578 17.868332 -49.659255 C 16.897761 -49.292232 16.114779 -48.492938 15.478606 -47.612083 C 13.0481 -44.28441 12.330366 -39.888293 11.841003 -35.687921 C 8.480705 -6.521845 12.28143 23.076503 9.418652 52.299671 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="butt"
                transform="matrix(0.478938, 0, 0, 0.478938, 258.979127, 100.84003)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="miter"
                d="M 31.41995 4.844312 C 31.41995 4.844312 -31.422504 4.844312 -31.422504 4.844312 C -31.422504 4.844312 -31.422504 -4.845089 -31.422504 -4.845089 C -31.422504 -4.845089 31.41995 -4.845089 31.41995 -4.845089 C 31.41995 -4.845089 31.41995 4.844312 31.41995 4.844312 Z M 31.41995 4.844312 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="10"
              />
              <path
                stroke-linecap="butt"
                transform="matrix(0.478938, 0, 0, 0.478938, 258.979127, 109.698953)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="miter"
                d="M 31.41995 4.845257 C 31.41995 4.845257 -31.422504 4.845257 -31.422504 4.845257 C -31.422504 4.845257 -31.422504 -4.844145 -31.422504 -4.844145 C -31.422504 -4.844145 31.41995 -4.844145 31.41995 -4.844145 C 31.41995 -4.844145 31.41995 4.845257 31.41995 4.845257 Z M 31.41995 4.845257 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="10"
              />
              <path
                stroke-linecap="butt"
                transform="matrix(0.478938, 0, 0, 0.478938, 258.979127, 105.272133)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="miter"
                d="M 33.361093 4.406996 C 33.361093 4.406996 -33.363647 4.406996 -33.363647 4.406996 C -33.363647 4.406996 -33.363647 -4.409706 -33.363647 -4.409706 C -33.363647 -4.409706 33.361093 -4.409706 33.361093 -4.409706 C 33.361093 -4.409706 33.361093 4.406996 33.361093 4.406996 Z M 33.361093 4.406996 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="10"
              />
              <path
                stroke-linecap="butt"
                transform="matrix(0.478938, 0, 0, 0.478938, 258.979127, 114.334601)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="miter"
                d="M 27.863908 4.839334 C 27.863908 4.839334 -27.866461 4.839334 -27.866461 4.839334 C -27.866461 4.839334 -27.866461 -4.833755 -27.866461 -4.833755 C -27.866461 -4.833755 27.863908 -4.833755 27.863908 -4.833755 C 27.863908 -4.833755 27.863908 4.839334 27.863908 4.839334 Z M 27.863908 4.839334 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="10"
              />
              <path
                stroke-linecap="butt"
                transform="matrix(0.478938, 0.000109451, -0.000109451, 0.478938, 146.638751, 299.180743)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="miter"
                d="M -49.005801 0.26999 C -39.278637 -12.936897 -26.655692 -24.480608 -12.686819 -35.249802 C -10.786791 -36.710171 -8.560425 -37.754656 -6.178914 -38.016194 C -2.31304 -38.449349 0.329898 -36.810584 1.953719 -33.46697 C 4.336409 -28.565722 2.926763 -22.644099 -1.044383 -18.899559 C -1.044383 -18.899559 -15.086092 -5.64275 -15.086092 -5.64275 C -7.680645 -6.769979 -0.756654 -8.981854 5.824603 -11.976633 C 14.314179 -15.844546 20.878174 -22.998912 24.42409 -31.620679 C 24.46485 -31.710405 24.497454 -31.80013 24.530059 -31.881698 C 27.855883 -39.973271 39.19273 -40.318416 42.995253 -32.448686 C 43.435889 -31.535307 43.843911 -30.581142 44.219315 -29.594344 C 49.001654 -16.961697 45.881142 -2.696032 37.02599 7.501068 C 29.720077 15.895325 20.105723 23.083013 6.951213 28.411927 C 6.951213 28.411927 -33.14942 40.320785 -33.14942 40.320785 C -33.14942 40.320785 -49.005801 0.26999 -49.005801 0.26999 Z M -49.005801 0.26999 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="10"
              />
              <path
                fill="#d4d4d4"
                d="M 57.335938 373.203125 C 41.179688 384.914062 21.695312 358.027344 37.851562 346.320312 C 37.851562 346.320312 124.152344 295.167969 124.152344 295.167969 C 124.152344 295.167969 135.46875 318.941406 135.46875 318.941406 C 135.46875 318.941406 57.335938 373.203125 57.335938 373.203125 Z M 57.335938 373.203125 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                stroke-linecap="butt"
                transform="matrix(0.478938, 0.000109451, -0.000109451, 0.478938, 96.404493, 334.187831)"
                fill="none"
                stroke-linejoin="miter"
                d="M 57.917553 -81.484827 C 57.917553 -81.484827 81.557006 -31.852438 81.557006 -31.852438 C 81.557006 -31.852438 -81.554639 81.480689 -81.554639 81.480689 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="10"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000109451, -0.000109451, 0.478938, 41.978879, 365.737403)"
                fill="none"
                stroke-linejoin="round"
                d="M -16.390256 -35.212295 C -32.065931 1.681154 -0.453528 35.219812 32.06836 15.588895 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.000109451, -0.000109451, 0.478938, 89.72852, 315.571875)"
                fill="none"
                stroke-linejoin="round"
                d="M -71.865563 42.620426 C -71.865563 42.620426 71.865544 -42.618796 71.865544 -42.618796 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.0000581434, -0.0000581434, 0.478938, 261.008947, 307.343559)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 31.923712 26.821809 C 29.84224 13.01385 25.183408 -1.16082 19.325614 -15.506621 C 18.53424 -17.447667 17.384016 -19.258174 15.826038 -20.660827 C 13.321853 -22.919752 10.940252 -23.172301 8.656725 -21.769181 C 5.337456 -19.729763 4.065622 -15.512924 5.23239 -11.793902 C 5.23239 -11.793902 10.674588 5.545224 10.674588 5.545224 C 5.976145 1.002868 1.987222 -4.012625 -1.496067 -9.378891 C -5.982741 -16.294686 -7.998275 -24.426035 -7.428272 -32.011242 C -7.330561 -33.348848 -7.232848 -34.661985 -7.135131 -35.942499 C -6.727986 -41.366329 -12.144114 -45.508951 -17.176154 -43.453013 C -19.206914 -42.629004 -21.131594 -41.389049 -22.950198 -39.765772 C -29.245993 -34.121013 -31.920129 -25.458951 -30.630458 -17.1073 C -28.957151 -6.28441 -24.763566 4.994914 -16.33689 17.056707 C -16.33689 17.056707 7.074461 45.510363 7.074461 45.510363 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                fill="#d4d4d4"
                d="M 310.097656 366.113281 C 318.417969 375.84375 303.695312 388.425781 295.378906 378.695312 C 295.378906 378.695312 264.394531 329.140625 264.394531 329.140625 C 264.394531 329.140625 276.296875 320.191406 276.296875 320.191406 C 276.296875 320.191406 310.097656 366.113281 310.097656 366.113281 Z M 310.097656 366.113281 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.0000581434, -0.0000581434, 0.478938, 288.077933, 336.197154)"
                fill="none"
                stroke-linejoin="round"
                d="M 24.60314 33.416708 C 24.60314 33.416708 -24.602338 -33.416243 -24.602338 -33.416243 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0.0000581434, -0.0000581434, 0.478938, 288.652976, 356.968782)"
                fill="none"
                stroke-linejoin="round"
                d="M 50.660351 36.019108 C 43.88477 53.367874 25.566829 58.092457 14.048925 45.362243 C 14.048925 45.362243 -50.657516 -58.097699 -50.657516 -58.097699 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, -0.0000581434, 0.0000581434, 0.478938, 480.968933, 320.015881)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -36.305415 19.797975 C -31.63855 6.634658 -24.378073 -6.397847 -15.910505 -19.373113 C -14.760288 -21.126527 -13.292008 -22.684156 -11.489386 -23.768693 C -8.601929 -25.51374 -6.212227 -25.309548 -4.23868 -23.498663 C -1.368067 -20.863907 -0.920015 -16.484047 -2.771858 -13.05057 C -2.771858 -13.05057 -11.402911 2.934263 -11.402911 2.934263 C -5.929762 -0.629272 -1.060087 -4.796428 3.369214 -9.404065 C 9.095491 -15.349139 12.619832 -22.95016 13.501604 -30.502566 C 13.65673 -31.831986 13.803698 -33.136938 13.950663 -34.417421 C 14.579335 -39.816658 20.688594 -42.858127 25.239316 -39.888768 C 27.074284 -38.689605 28.729774 -37.115284 30.205784 -35.165806 C 35.318818 -28.436434 36.304607 -19.423866 33.449019 -11.463897 C 29.753073 -1.16324 23.496125 9.120794 12.932782 19.363525 C 12.932782 19.363525 -15.453166 42.865849 -15.453166 42.865849 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                fill="#d4d4d4"
                d="M 421.683594 368.171875 C 411.667969 376.148438 423.734375 391.296875 433.746094 383.320312 C 433.746094 383.320312 473.570312 340.546875 473.570312 340.546875 C 473.570312 340.546875 463.582031 329.5 463.582031 329.5 C 463.582031 329.5 421.683594 368.171875 421.683594 368.171875 Z M 421.683594 368.171875 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, -0.0000581434, 0.0000581434, 0.478938, 448.978141, 342.979115)"
                fill="none"
                stroke-linejoin="round"
                d="M -30.49407 28.145692 C -30.49407 28.145692 30.495635 -28.140041 30.495635 -28.140041 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, -0.0000581434, 0.0000581434, 0.478938, 445.4764, 364.404357)"
                fill="none"
                stroke-linejoin="round"
                d="M -58.669049 23.372103 C -55.310976 41.691025 -38.225012 49.80838 -24.497108 39.492629 C -24.497108 39.492629 58.664781 -49.80615 58.664781 -49.80615 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 256.787053, 426.373942)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 513.534303 50.692132 C 513.534303 50.692132 -513.534069 50.692132 -513.534069 50.692132 C -513.534069 50.692132 -415.865231 -50.687714 -415.865231 -50.687714 C -415.865231 -50.687714 440.480459 -50.687714 440.480459 -50.687714 C 440.480459 -50.687714 513.534303 50.692132 513.534303 50.692132 Z M 513.534303 50.692132 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 130.235263, 428.664696)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -88.85399 33.797396 C -88.85399 33.797396 -32.169362 -35.741185 -32.169362 -35.741185 C -32.169362 -35.741185 88.85028 -35.741185 88.85028 -35.741185 C 88.85028 -35.741185 50.549415 35.746695 50.549415 35.746695 C 50.549415 35.746695 -88.85399 33.797396 -88.85399 33.797396 Z M -88.85399 33.797396 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 8.44174, 399.701395)"
                fill="none"
                stroke-linejoin="round"
                d="M 194.211443 78.856416 C 194.211443 78.856416 292.508297 78.856416 292.508297 78.856416 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 8.44174, 399.701395)"
                fill="none"
                stroke-linejoin="round"
                d="M 208.509019 63.0255 C 208.509019 63.0255 306.814029 63.0255 306.814029 63.0255 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 8.44174, 399.701395)"
                fill="none"
                stroke-linejoin="round"
                d="M 199.276357 70.684042 C 199.276357 70.684042 302.874652 70.684042 302.874652 70.684042 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 137.674128, 419.982505)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -42.726154 -9.701809 C -42.726154 -9.701809 -57.407065 9.701461 -57.407065 9.701461 C -57.407065 9.701461 44.4703 9.701461 44.4703 9.701461 C 44.4703 9.701461 57.405814 -9.701809 57.405814 -9.701809 C 57.405814 -9.701809 -42.726154 -9.701809 -42.726154 -9.701809 Z M -42.726154 -9.701809 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 112.300466, 424.629144)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -88.851477 33.790067 C -88.851477 33.790067 -32.166849 -35.748515 -32.166849 -35.748515 C -32.166849 -35.748515 88.852794 -35.748515 88.852794 -35.748515 C 88.852794 -35.748515 50.551928 35.747521 50.551928 35.747521 C 50.551928 35.747521 -88.851477 33.790067 -88.851477 33.790067 Z M -88.851477 33.790067 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 8.44174, 399.701395)"
                fill="none"
                stroke-linejoin="round"
                d="M 156.766964 70.431204 C 156.766964 70.431204 255.063818 70.431204 255.063818 70.431204 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 8.44174, 399.701395)"
                fill="none"
                stroke-linejoin="round"
                d="M 171.06454 54.600288 C 171.06454 54.600288 269.361394 54.600288 269.361394 54.600288 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 8.44174, 399.701395)"
                fill="none"
                stroke-linejoin="round"
                d="M 161.831878 62.25883 C 161.831878 62.25883 265.430173 62.25883 265.430173 62.25883 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 8.44174, 399.701395)"
                fill="none"
                stroke-linejoin="round"
                d="M 175.615622 43.875067 C 175.615622 43.875067 273.912477 43.875067 273.912477 43.875067 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 8.44174, 399.701395)"
                fill="none"
                stroke-linejoin="round"
                d="M 189.913198 28.044152 C 189.913198 28.044152 288.210053 28.044152 288.210053 28.044152 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 8.44174, 399.701395)"
                fill="none"
                stroke-linejoin="round"
                d="M 180.680536 35.71085 C 180.680536 35.71085 284.278831 35.71085 284.278831 35.71085 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 318.44794, 426.64692)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -252.256161 -31.528166 C -252.256161 -31.528166 245.108633 -31.528166 245.108633 -31.528166 C 245.108633 -31.528166 282.895666 31.534502 282.895666 31.534502 C 282.895666 31.534502 -282.890328 31.534502 -282.890328 31.534502 C -282.890328 31.534502 -252.256161 -31.528166 -252.256161 -31.528166 Z M -252.256161 -31.528166 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                fill="#ffffff"
                d="M 201.300781 415.335938 C 201.300781 415.335938 190.785156 437.46875 190.785156 437.46875 C 190.785156 437.46875 281.273438 437.46875 281.273438 437.46875 C 281.273438 437.46875 284.453125 415.335938 284.453125 415.335938 C 284.453125 415.335938 201.300781 415.335938 201.300781 415.335938 Z M 201.300781 415.335938 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 202.121508, 416.633327)"
                fill="none"
                stroke-linejoin="round"
                d="M 4.289223 -2.708886 C 4.289223 -2.708886 -1.713638 -2.708886 -1.713638 -2.708886 C -1.713638 -2.708886 -4.290954 2.706739 -4.290954 2.706739 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                fill="#231f1f"
                d="M 197.816406 423.785156 L 195.804688 428.019531 L 195.089844 429.53125 C 195.03125 429.648438 194.941406 429.730469 194.816406 429.773438 C 194.691406 429.820312 194.570312 429.8125 194.449219 429.757812 C 194.332031 429.699219 194.25 429.609375 194.203125 429.484375 C 194.160156 429.359375 194.167969 429.238281 194.222656 429.117188 L 194.941406 427.609375 L 196.953125 423.371094 C 197.007812 423.253906 197.101562 423.171875 197.226562 423.128906 C 197.347656 423.082031 197.472656 423.089844 197.589844 423.144531 C 197.710938 423.203125 197.792969 423.292969 197.835938 423.417969 C 197.878906 423.542969 197.875 423.664062 197.816406 423.785156 Z M 197.816406 423.785156 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 192.22233, 436.171089)"
                fill="none"
                stroke-linejoin="round"
                d="M -0.423434 -2.706171 C -0.423434 -2.706171 -3.00075 2.709454 -3.00075 2.709454 C -3.00075 2.709454 3.002112 2.709454 3.002112 2.709454 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                fill="#231f1f"
                d="M 199.308594 436.988281 L 204.816406 436.988281 C 204.949219 436.988281 205.0625 437.035156 205.15625 437.128906 C 205.246094 437.222656 205.292969 437.335938 205.292969 437.46875 C 205.292969 437.601562 205.246094 437.714844 205.15625 437.808594 C 205.0625 437.902344 204.949219 437.949219 204.816406 437.949219 L 199.308594 437.949219 C 199.175781 437.949219 199.0625 437.902344 198.96875 437.808594 C 198.875 437.714844 198.828125 437.601562 198.828125 437.46875 C 198.828125 437.335938 198.875 437.222656 198.96875 437.128906 C 199.0625 437.035156 199.175781 436.988281 199.308594 436.988281 Z M 210.554688 436.988281 L 216.214844 436.988281 C 216.347656 436.988281 216.460938 437.035156 216.554688 437.128906 C 216.648438 437.222656 216.695312 437.335938 216.695312 437.46875 C 216.695312 437.601562 216.648438 437.714844 216.554688 437.808594 C 216.460938 437.902344 216.347656 437.949219 216.214844 437.949219 L 210.554688 437.949219 C 210.421875 437.949219 210.308594 437.902344 210.214844 437.808594 C 210.121094 437.714844 210.074219 437.601562 210.074219 437.46875 C 210.074219 437.335938 210.121094 437.222656 210.214844 437.128906 C 210.308594 437.035156 210.421875 436.988281 210.554688 436.988281 Z M 221.859375 436.988281 L 227.449219 436.988281 C 227.582031 436.988281 227.695312 437.035156 227.789062 437.128906 C 227.882812 437.222656 227.929688 437.335938 227.929688 437.46875 C 227.929688 437.601562 227.882812 437.714844 227.789062 437.808594 C 227.695312 437.902344 227.582031 437.949219 227.449219 437.949219 L 221.859375 437.949219 C 221.726562 437.949219 221.613281 437.902344 221.519531 437.808594 C 221.425781 437.714844 221.378906 437.601562 221.378906 437.46875 C 221.378906 437.335938 221.425781 437.222656 221.519531 437.128906 C 221.613281 437.035156 221.726562 436.988281 221.859375 436.988281 Z M 233.125 436.988281 L 238.886719 436.988281 C 239.015625 436.988281 239.128906 437.035156 239.222656 437.128906 C 239.316406 437.222656 239.363281 437.335938 239.363281 437.46875 C 239.363281 437.601562 239.316406 437.714844 239.222656 437.808594 C 239.128906 437.902344 239.015625 437.949219 238.886719 437.949219 L 233.125 437.949219 C 232.992188 437.949219 232.878906 437.902344 232.785156 437.808594 C 232.691406 437.714844 232.644531 437.601562 232.644531 437.46875 C 232.644531 437.335938 232.691406 437.222656 232.785156 437.128906 C 232.878906 437.035156 232.992188 436.988281 233.125 436.988281 Z M 244.617188 436.988281 L 250.203125 436.988281 C 250.335938 436.988281 250.445312 437.035156 250.539062 437.128906 C 250.632812 437.222656 250.679688 437.335938 250.679688 437.46875 C 250.679688 437.601562 250.632812 437.714844 250.539062 437.808594 C 250.445312 437.902344 250.335938 437.949219 250.203125 437.949219 L 244.617188 437.949219 C 244.484375 437.949219 244.371094 437.902344 244.277344 437.808594 C 244.183594 437.714844 244.136719 437.601562 244.136719 437.46875 C 244.136719 437.335938 244.183594 437.222656 244.277344 437.128906 C 244.371094 437.035156 244.484375 436.988281 244.617188 436.988281 Z M 255.867188 436.988281 L 261.546875 436.988281 C 261.679688 436.988281 261.792969 437.035156 261.886719 437.128906 C 261.980469 437.222656 262.027344 437.335938 262.027344 437.46875 C 262.027344 437.601562 261.980469 437.714844 261.886719 437.808594 C 261.792969 437.902344 261.679688 437.949219 261.546875 437.949219 L 255.867188 437.949219 C 255.734375 437.949219 255.621094 437.902344 255.527344 437.808594 C 255.433594 437.714844 255.386719 437.601562 255.386719 437.46875 C 255.386719 437.335938 255.433594 437.222656 255.527344 437.128906 C 255.621094 437.035156 255.734375 436.988281 255.867188 436.988281 Z M 267.207031 436.988281 L 272.789062 436.988281 C 272.921875 436.988281 273.035156 437.035156 273.128906 437.128906 C 273.222656 437.222656 273.269531 437.335938 273.269531 437.46875 C 273.269531 437.601562 273.222656 437.714844 273.128906 437.808594 C 273.035156 437.902344 272.921875 437.949219 272.789062 437.949219 L 267.207031 437.949219 C 267.078125 437.949219 266.964844 437.902344 266.871094 437.808594 C 266.777344 437.714844 266.730469 437.601562 266.730469 437.46875 C 266.730469 437.335938 266.777344 437.222656 266.871094 437.128906 C 266.964844 437.035156 267.078125 436.988281 267.207031 436.988281 Z M 267.207031 436.988281 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 280.041406, 436.046601)"
                fill="none"
                stroke-linejoin="round"
                d="M -3.422282 2.969379 C -3.422282 2.969379 2.572423 2.969379 2.572423 2.969379 C 2.572423 2.969379 3.428809 -2.968234 3.428809 -2.968234 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                fill="#231f1f"
                d="M 281.996094 429.074219 L 282.585938 424.964844 L 282.796875 423.5 C 282.816406 423.367188 282.878906 423.261719 282.984375 423.183594 C 283.089844 423.105469 283.207031 423.074219 283.339844 423.09375 C 283.46875 423.109375 283.574219 423.171875 283.65625 423.277344 C 283.734375 423.386719 283.765625 423.503906 283.746094 423.632812 L 283.535156 425.101562 L 282.945312 429.210938 C 282.925781 429.339844 282.863281 429.445312 282.757812 429.527344 C 282.652344 429.605469 282.53125 429.636719 282.402344 429.617188 C 282.269531 429.597656 282.164062 429.535156 282.085938 429.429688 C 282.007812 429.324219 281.976562 429.207031 281.996094 429.074219 Z M 281.996094 429.074219 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 283.016572, 416.757815)"
                fill="none"
                stroke-linejoin="round"
                d="M 2.143068 2.968802 C 2.143068 2.968802 2.999454 -2.968811 2.999454 -2.968811 C 2.999454 -2.968811 -3.003407 -2.968811 -3.003407 -2.968811 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                fill="#231f1f"
                d="M 275.625 415.816406 L 269.722656 415.816406 C 269.589844 415.816406 269.476562 415.769531 269.382812 415.675781 C 269.292969 415.582031 269.246094 415.46875 269.246094 415.335938 C 269.246094 415.203125 269.292969 415.089844 269.382812 414.996094 C 269.476562 414.902344 269.589844 414.855469 269.722656 414.855469 L 275.625 414.855469 C 275.757812 414.855469 275.871094 414.902344 275.964844 414.996094 C 276.058594 415.089844 276.105469 415.203125 276.105469 415.335938 C 276.105469 415.46875 276.058594 415.582031 275.964844 415.675781 C 275.871094 415.769531 275.757812 415.816406 275.625 415.816406 Z M 263.78125 415.816406 L 257.820312 415.816406 C 257.6875 415.816406 257.574219 415.769531 257.480469 415.675781 C 257.386719 415.582031 257.34375 415.46875 257.34375 415.335938 C 257.34375 415.203125 257.386719 415.089844 257.480469 414.996094 C 257.574219 414.902344 257.6875 414.855469 257.820312 414.855469 L 263.78125 414.855469 C 263.914062 414.855469 264.027344 414.902344 264.121094 414.996094 C 264.214844 415.089844 264.261719 415.203125 264.261719 415.335938 C 264.261719 415.46875 264.214844 415.582031 264.121094 415.675781 C 264.027344 415.769531 263.914062 415.816406 263.78125 415.816406 Z M 251.878906 415.816406 L 245.9375 415.816406 C 245.804688 415.816406 245.691406 415.769531 245.597656 415.675781 C 245.503906 415.582031 245.457031 415.46875 245.457031 415.335938 C 245.457031 415.203125 245.503906 415.089844 245.597656 414.996094 C 245.691406 414.902344 245.804688 414.855469 245.9375 414.855469 L 251.878906 414.855469 C 252.011719 414.855469 252.125 414.902344 252.21875 414.996094 C 252.308594 415.089844 252.355469 415.203125 252.355469 415.335938 C 252.355469 415.46875 252.308594 415.582031 252.21875 415.675781 C 252.125 415.769531 252.011719 415.816406 251.878906 415.816406 Z M 239.871094 415.816406 L 233.84375 415.816406 C 233.710938 415.816406 233.597656 415.769531 233.503906 415.675781 C 233.410156 415.582031 233.363281 415.46875 233.363281 415.335938 C 233.363281 415.203125 233.410156 415.089844 233.503906 414.996094 C 233.597656 414.902344 233.710938 414.855469 233.84375 414.855469 L 239.871094 414.855469 C 240 414.855469 240.113281 414.902344 240.207031 414.996094 C 240.300781 415.089844 240.347656 415.203125 240.347656 415.335938 C 240.347656 415.46875 240.300781 415.582031 240.207031 415.675781 C 240.113281 415.769531 240 415.816406 239.871094 415.816406 Z M 227.964844 415.816406 L 221.984375 415.816406 C 221.851562 415.816406 221.738281 415.769531 221.648438 415.675781 C 221.554688 415.582031 221.507812 415.46875 221.507812 415.335938 C 221.507812 415.203125 221.554688 415.089844 221.648438 414.996094 C 221.738281 414.902344 221.851562 414.855469 221.984375 414.855469 L 227.964844 414.855469 C 228.09375 414.855469 228.207031 414.902344 228.300781 414.996094 C 228.394531 415.089844 228.441406 415.203125 228.441406 415.335938 C 228.441406 415.46875 228.394531 415.582031 228.300781 415.675781 C 228.207031 415.769531 228.09375 415.816406 227.964844 415.816406 Z M 215.976562 415.816406 L 210.125 415.816406 C 209.992188 415.816406 209.878906 415.769531 209.785156 415.675781 C 209.691406 415.582031 209.644531 415.46875 209.644531 415.335938 C 209.644531 415.203125 209.691406 415.089844 209.785156 414.996094 C 209.878906 414.902344 209.992188 414.855469 210.125 414.855469 L 215.976562 414.855469 C 216.109375 414.855469 216.222656 414.902344 216.316406 414.996094 C 216.410156 415.089844 216.453125 415.203125 216.453125 415.335938 C 216.453125 415.46875 216.410156 415.582031 216.316406 415.675781 C 216.222656 415.769531 216.109375 415.816406 215.976562 415.816406 Z M 215.976562 415.816406 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 8.44174, 399.701395)"
                fill="none"
                stroke-linejoin="round"
                d="M 591.109869 42.349884 C 591.109869 42.349884 693.240073 42.349884 693.240073 42.349884 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="butt"
                transform="matrix(0.478938, 0, 0, 0.478938, 8.44174, 399.701395)"
                fill="none"
                stroke-linejoin="miter"
                d="M 591.109869 53.833619 C 591.109869 53.833619 693.240073 53.833619 693.240073 53.833619 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="10"
              />
              <path
                stroke-linecap="butt"
                transform="matrix(0.478938, 0, 0, 0.478938, 8.44174, 399.701395)"
                fill="none"
                stroke-linejoin="miter"
                d="M 588.04319 68.473749 C 588.04319 68.473749 697.660658 68.473749 697.660658 68.473749 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="10"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 236.029856, 426.707787)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -66.216153 -14.046316 C -66.216153 -14.046316 -77.789605 14.04316 -77.789605 14.04316 C -77.789605 14.04316 -18.576597 14.04316 -18.576597 14.04316 C -18.576597 14.04316 -15.151051 -2.554425 -15.151051 -2.554425 C -15.151051 -2.554425 75.740099 -2.554425 75.740099 -2.554425 C 75.740099 -2.554425 77.787271 -14.046316 77.787271 -14.046316 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="butt"
                transform="matrix(0.478938, 0, 0, 0.478938, 256.78752, 458.489629)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 513.533328 16.366401 C 513.533328 16.366401 -513.535044 16.366401 -513.535044 16.366401 C -513.535044 16.366401 -513.535044 -16.363874 -513.535044 -16.363874 C -513.535044 -16.363874 513.533328 -16.363874 513.533328 -16.363874 C 513.533328 -16.363874 513.533328 16.366401 513.533328 16.366401 Z M 513.533328 16.366401 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 400.850719, 421.449966)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 88.853897 33.79716 C 88.853897 33.79716 32.169269 -35.741422 32.169269 -35.741422 C 32.169269 -35.741422 -88.850374 -35.741422 -88.850374 -35.741422 C -88.850374 -35.741422 -50.549508 35.746458 -50.549508 35.746458 C -50.549508 35.746458 88.853897 33.79716 88.853897 33.79716 Z M 88.853897 33.79716 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 8.44174, 399.701395)"
                fill="none"
                stroke-linejoin="round"
                d="M 879.418492 63.79217 C 879.418492 63.79217 781.121637 63.79217 781.121637 63.79217 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 8.44174, 399.701395)"
                fill="none"
                stroke-linejoin="round"
                d="M 865.120916 47.961254 C 865.120916 47.961254 766.824061 47.961254 766.824061 47.961254 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 8.44174, 399.701395)"
                fill="none"
                stroke-linejoin="round"
                d="M 874.353577 55.619796 C 874.353577 55.619796 770.755283 55.619796 770.755283 55.619796 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 393.41184, 412.767799)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 42.726091 -9.702096 C 42.726091 -9.702096 57.407002 9.701175 57.407002 9.701175 C 57.407002 9.701175 -44.470364 9.701175 -44.470364 9.701175 C -44.470364 9.701175 -57.405877 -9.702096 -57.405877 -9.702096 C -57.405877 -9.702096 42.726091 -9.702096 42.726091 -9.702096 Z M 42.726091 -9.702096 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 443.404847, 426.64692)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 88.855064 33.793731 C 88.855064 33.793731 32.170436 -35.74485 32.170436 -35.74485 C 32.170436 -35.74485 -88.849207 -35.74485 -88.849207 -35.74485 C -88.849207 -35.74485 -50.556497 35.74303 -50.556497 35.74303 C -50.556497 35.74303 88.855064 33.793731 88.855064 33.793731 Z M 88.855064 33.793731 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 8.44174, 399.701395)"
                fill="none"
                stroke-linejoin="round"
                d="M 968.270627 74.647888 C 968.270627 74.647888 869.965616 74.647888 869.965616 74.647888 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 8.44174, 399.701395)"
                fill="none"
                stroke-linejoin="round"
                d="M 953.973051 58.816972 C 953.973051 58.816972 855.66804 58.816972 855.66804 58.816972 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 8.44174, 399.701395)"
                fill="none"
                stroke-linejoin="round"
                d="M 963.205713 66.475514 C 963.205713 66.475514 859.607418 66.475514 859.607418 66.475514 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 8.44174, 399.701395)"
                fill="none"
                stroke-linejoin="round"
                d="M 949.413812 48.091751 C 949.413812 48.091751 851.116958 48.091751 851.116958 48.091751 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 8.44174, 399.701395)"
                fill="none"
                stroke-linejoin="round"
                d="M 935.116236 32.260836 C 935.116236 32.260836 836.819382 32.260836 836.819382 32.260836 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.478938, 0, 0, 0.478938, 8.44174, 399.701395)"
                fill="none"
                stroke-linejoin="round"
                d="M 944.348898 39.919377 C 944.348898 39.919377 840.75876 39.919377 840.75876 39.919377 "
                stroke="#231f1f"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="butt"
                transform="matrix(0.74863, 0, 0, 0.748558, 64.126437, 488.957891)"
                fill="none"
                stroke-linejoin="miter"
                d="M -0.00191953 1.997487 L 484.96205 1.997487 "
                stroke="#000000"
                stroke-width="4"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
            </svg>
          </div>
        </div>
      </div>

      <div className="mainSection">
        <div className="contentBox">
          <h1>We'll help you in creative ways</h1>
          <p>
            Discover our creative and customized solutions that will
            revolutionize your business. We combine cutting-edge technology with
            strategic thinking to deliver exceptional results. Experience the
            power of digital transformation with Manognaa Solutions.
          </p>
          <div className="btnBox">
            <div className="btn">
              <NavLink to="/about" className="readMore">
                Know more
              </NavLink>
            </div>
          </div>
        </div>
        <div className="imageContainerCenter">
          <div className="svgGraphic">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xlinkHref="http://www.w3.org/1999/xlink"
              zoomAndPan="magnify"
              viewBox="0 0 421.5 379.499984"
              preserveAspectRatio="xMidYMid meet"
              version="1.0"
            >
              <path
                stroke-linecap="round"
                transform="matrix(0.32027, -0.309348, 0.309281, 0.320339, 325.302933, 53.895792)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 73.510414 -16.325635 C 73.510414 -16.325635 58.293326 -47.665571 58.293326 -47.665571 C 58.293326 -47.665571 41.652878 -39.590713 41.652878 -39.590713 C 39.402601 -41.958886 36.963649 -44.119049 34.379981 -46.040944 C 34.379981 -46.040944 40.432194 -63.523734 40.432194 -63.523734 C 40.432194 -63.523734 7.511144 -74.926655 7.511144 -74.926655 C 7.511144 -74.926655 1.458931 -57.443865 1.458931 -57.443865 C -1.768867 -57.536773 -5.010371 -57.350256 -8.252956 -56.872126 C -8.252956 -56.872126 -16.337571 -73.507886 -16.337571 -73.507886 C -16.337571 -73.507886 -47.668142 -58.291604 -47.668142 -58.291604 C -47.668142 -58.291604 -39.589838 -41.661939 -39.589838 -41.661939 C -41.963635 -39.405882 -44.123286 -36.967416 -46.05073 -34.377874 C -46.05073 -34.377874 -63.528653 -40.42773 -63.528653 -40.42773 C -63.528653 -40.42773 -74.924536 -7.5094 -74.924536 -7.5094 C -74.924536 -7.5094 -57.446612 -1.459543 -57.446612 -1.459543 C -57.526417 1.767996 -57.345291 5.015824 -56.872767 8.252394 C -56.872767 8.252394 -73.513215 16.327252 -73.513215 16.327252 C -73.513215 16.327252 -58.289817 47.673282 -58.289817 47.673282 C -58.289817 47.673282 -41.655679 39.59233 -41.655679 39.59233 C -39.405403 41.960503 -36.972544 44.126975 -34.382783 46.04256 C -34.382783 46.04256 -40.434995 63.525351 -40.434995 63.525351 C -40.434995 63.525351 -7.513946 74.928272 -7.513946 74.928272 C -7.513946 74.928272 -1.461733 57.445482 -1.461733 57.445482 C 1.766066 57.538389 5.013662 57.345563 8.250155 56.873743 C 8.250155 56.873743 16.334769 73.509503 16.334769 73.509503 C 16.334769 73.509503 47.66534 58.293221 47.66534 58.293221 C 47.66534 58.293221 39.59313 41.657246 39.59313 41.657246 C 41.966927 39.401189 44.120485 36.969032 46.047928 34.379491 C 46.047928 34.379491 63.525852 40.429347 63.525852 40.429347 C 63.525852 40.429347 74.934139 7.510801 74.934139 7.510801 C 74.934139 7.510801 57.449904 1.45485 57.449904 1.45485 C 57.53602 -1.766594 57.34249 -5.014208 56.869965 -8.250778 C 56.869965 -8.250778 73.510414 -16.325635 73.510414 -16.325635 Z M 23.998284 -10.131196 C 26.399874 -4.446432 26.631109 1.654433 25.028854 7.216322 C 24.777515 8.095466 24.476341 8.963067 24.131424 9.812813 C 21.948544 15.16763 17.991363 19.821135 12.596308 22.793444 C 12.190662 23.011422 11.791108 23.22309 11.372839 23.428878 C 10.960664 23.628356 10.54827 23.81543 10.129566 23.996409 C 4.451371 26.39044 -1.649273 26.632758 -7.211552 25.02931 C -8.090757 24.777784 -8.958429 24.476424 -9.808257 24.131325 C -15.163586 21.947302 -19.817767 18.001549 -22.797578 12.599797 C -23.015645 12.194107 -23.2274 11.794511 -23.426969 11.382295 C -23.63285 10.963985 -23.820014 10.551554 -23.994992 10.126503 C -26.402675 4.448049 -26.627818 -1.659126 -25.025344 -7.208611 C -24.767912 -8.094065 -24.466738 -8.961665 -24.128132 -9.817506 C -21.945252 -15.172323 -17.994164 -19.819519 -12.593016 -22.798137 C -12.193463 -23.009805 -11.787817 -23.227783 -11.375641 -23.427261 C -10.963465 -23.626739 -10.544761 -23.807718 -10.126056 -23.988698 C -4.448079 -26.395133 1.652782 -26.625046 7.20875 -25.027694 C 8.087955 -24.776167 8.955627 -24.474807 9.805455 -24.129708 C 15.166878 -21.951995 19.814965 -17.999932 22.794776 -12.598181 C 23.019154 -12.186395 23.23091 -11.786799 23.430479 -11.374584 C 23.630048 -10.962368 23.823524 -10.543842 23.998284 -10.131196 Z M 23.998284 -10.131196 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.297915, 0.33094, -0.330868, 0.29798, 74.792951, 260.899987)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 114.675262 27.270197 C 114.675262 27.270197 114.680266 -27.269299 114.680266 -27.269299 C 114.680266 -27.269299 85.727517 -27.270686 85.727517 -27.270686 C 84.180489 -32.146424 82.219998 -36.851367 79.904713 -41.332689 C 79.904713 -41.332689 100.375727 -61.813285 100.375727 -61.813285 C 100.375727 -61.813285 61.8159 -100.369675 61.8159 -100.369675 C 61.8159 -100.369675 41.338368 -79.894949 41.338368 -79.894949 C 36.855579 -82.231197 32.150313 -84.189268 27.261682 -85.733944 C 27.261682 -85.733944 27.269305 -114.687348 27.269305 -114.687348 C 27.269305 -114.687348 -27.263089 -114.687123 -27.263089 -114.687123 C -27.263089 -114.687123 -27.264841 -85.74024 -27.264841 -85.74024 C -32.153192 -84.191475 -36.858451 -82.229927 -41.338875 -79.888845 C -41.338875 -79.888845 -61.815246 -100.3683 -61.815246 -100.3683 C -61.815246 -100.3683 -100.379721 -61.811685 -100.379721 -61.811685 C -100.379721 -61.811685 -79.903349 -41.33223 -79.903349 -41.33223 C -82.22225 -36.856008 -84.18129 -32.150213 -85.727633 -27.273528 C -85.727633 -27.273528 -114.680381 -27.274915 -114.680381 -27.274915 C -114.680381 -27.274915 -114.678866 27.270452 -114.678866 27.270452 C -114.678866 27.270452 -85.726118 27.271838 -85.726118 27.271838 C -84.179089 32.147577 -82.230988 36.85317 -79.897443 41.327321 C -79.897443 41.327321 -100.380846 61.808567 -100.380846 61.808567 C -100.380846 61.808567 -61.8145 100.370828 -61.8145 100.370828 C -61.8145 100.370828 -41.336968 79.896102 -41.336968 79.896102 C -36.854179 82.232349 -32.155432 84.18455 -27.260282 85.735096 C -27.260282 85.735096 -27.262034 114.68198 -27.262034 114.68198 C -27.262034 114.68198 27.264489 114.688275 27.264489 114.688275 C 27.264489 114.688275 27.259722 85.735522 27.259722 85.735522 C 32.153944 84.180238 36.853332 82.22521 41.334404 79.896518 C 41.334404 79.896518 61.816646 100.369452 61.816646 100.369452 C 61.816646 100.369452 100.381121 61.812837 100.381121 61.812837 C 100.381121 61.812837 79.898231 41.327513 79.898231 41.327513 C 82.229521 36.85064 84.18269 32.151366 85.734903 27.26816 C 85.734903 27.26816 114.675262 27.270197 114.675262 27.270197 Z M 40.715892 2.15158 C 40.213876 11.793745 36.36644 20.536965 30.314403 27.271542 C 29.345091 28.334964 28.336018 29.350779 27.268278 30.31377 C 20.528543 36.37011 11.778588 40.215034 2.145546 40.714715 C 1.432835 40.745932 0.719476 40.76476 -0.00105043 40.765329 C -0.721576 40.765898 -1.43688 40.747557 -2.14696 40.710307 C -11.77641 40.209706 -20.530994 36.364717 -27.264115 30.313994 C -28.333175 29.351409 -29.34875 28.342533 -30.311488 27.274976 C -36.36624 20.536393 -40.215063 11.793588 -40.719177 2.154567 C -40.75024 1.441846 -40.768913 0.728474 -40.769327 0.00793225 C -40.776259 -0.718479 -40.751246 -1.427933 -40.714492 -2.150427 C -40.212476 -11.792593 -36.36504 -20.535813 -30.313003 -27.27039 C -29.35021 -28.339681 -28.334619 -29.349627 -27.261008 -30.319137 C -20.527143 -36.368958 -11.777188 -40.213882 -2.144147 -40.713563 C -1.431435 -40.74478 -0.724595 -40.769477 0.00245012 -40.764177 C 0.722976 -40.764746 1.438279 -40.746405 2.141841 -40.715024 C 11.77781 -40.208554 20.532394 -36.363565 27.265515 -30.312842 C 28.334574 -29.350257 29.350149 -28.34138 30.312888 -27.273824 C 36.361121 -20.54111 40.216463 -11.792435 40.720576 -2.153415 C 40.752287 -1.428304 40.770961 -0.714933 40.771375 0.00560948 C 40.771788 0.726152 40.753294 1.441475 40.715892 2.15158 Z M 40.715892 2.15158 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 55.355805, 177.211832)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 46.11336 10.962635 C 46.11336 10.962635 46.11336 -10.96665 46.11336 -10.96665 C 46.11336 -10.96665 34.470775 -10.96665 34.470775 -10.96665 C 33.847848 -12.931514 33.066997 -14.817432 32.12822 -16.624405 C 32.12822 -16.624405 40.366643 -24.852273 40.366643 -24.852273 C 40.366643 -24.852273 24.854894 -40.360662 24.854894 -40.360662 C 24.854894 -40.360662 16.625244 -32.124023 16.625244 -32.124023 C 14.81788 -33.062597 12.931553 -33.852051 10.966263 -34.474843 C 10.966263 -34.474843 10.966263 -46.114907 10.966263 -46.114907 C 10.966263 -46.114907 -10.967772 -46.114907 -10.967772 -46.114907 C -10.967772 -46.114907 -10.967772 -34.474843 -10.967772 -34.474843 C -12.933061 -33.852051 -14.819388 -33.062597 -16.626753 -32.124023 C -16.626753 -32.124023 -24.856403 -40.360662 -24.856403 -40.360662 C -24.856403 -40.360662 -40.368152 -24.852273 -40.368152 -24.852273 C -40.368152 -24.852273 -32.129729 -16.624405 -32.129729 -16.624405 C -33.059732 -14.817432 -33.849357 -12.931514 -34.472284 -10.96665 C -34.472284 -10.96665 -46.114869 -10.96665 -46.114869 -10.96665 C -46.114869 -10.96665 -46.114869 10.962635 -46.114869 10.962635 C -46.114869 10.962635 -34.472284 10.962635 -34.472284 10.962635 C -33.849357 12.927498 -33.068505 14.822189 -32.129729 16.62039 C -32.129729 16.62039 -40.368152 24.857029 -40.368152 24.857029 C -40.368152 24.857029 -24.856403 40.365419 -24.856403 40.365419 C -24.856403 40.365419 -16.626753 32.12878 -16.626753 32.12878 C -14.819388 33.067353 -12.933061 33.856807 -10.967772 34.479599 C -10.967772 34.479599 -10.967772 46.119663 -10.967772 46.119663 C -10.967772 46.119663 10.966263 46.119663 10.966263 46.119663 C 10.966263 46.119663 10.966263 34.479599 10.966263 34.479599 C 12.931553 33.856807 14.81788 33.067353 16.625244 32.12878 C 16.625244 32.12878 24.854894 40.365419 24.854894 40.365419 C 24.854894 40.365419 40.366643 24.857029 40.366643 24.857029 C 40.366643 24.857029 32.12822 16.62039 32.12822 16.62039 C 33.066997 14.822189 33.847848 12.927498 34.470775 10.962635 C 34.470775 10.962635 46.11336 10.962635 46.11336 10.962635 Z M 16.370809 0.866392 C 16.169016 4.74349 14.62486 8.260947 12.185795 10.962635 C 11.799756 11.392449 11.39617 11.804719 10.966263 12.190675 C 8.255216 14.629211 4.736997 16.173033 0.85906 16.374782 C 0.578304 16.383554 0.288775 16.392325 -0.000754357 16.392325 C -0.290284 16.392325 -0.579813 16.383554 -0.860569 16.374782 C -4.738506 16.173033 -8.256725 14.629211 -10.967772 12.190675 C -11.388905 11.804719 -11.801265 11.392449 -12.187304 10.962635 C -14.626369 8.260947 -16.170525 4.74349 -16.372318 0.866392 C -16.389865 0.576926 -16.398639 0.296231 -16.398639 -0.00200755 C -16.398639 -0.291474 -16.389865 -0.572169 -16.372318 -0.861636 C -16.170525 -4.738733 -14.626369 -8.25619 -12.187304 -10.96665 C -11.801265 -11.396464 -11.388905 -11.799963 -10.967772 -12.19469 C -8.256725 -14.624454 -4.738506 -16.168276 -0.860569 -16.370025 C -0.579813 -16.387569 -0.290284 -16.396341 -0.000754357 -16.396341 C 0.288775 -16.396341 0.578304 -16.387569 0.85906 -16.370025 C 4.736997 -16.168276 8.255216 -14.624454 10.966263 -12.19469 C 11.39617 -11.799963 11.799756 -11.396464 12.185795 -10.96665 C 14.62486 -8.25619 16.169016 -4.738733 16.370809 -0.861636 C 16.388356 -0.572169 16.39713 -0.291474 16.39713 -0.00200755 C 16.39713 0.296231 16.388356 0.576926 16.370809 0.866392 Z M 16.370809 0.866392 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 45.625664, 81.526168)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 81.45274 -26.119524 C 87.471439 -3.663937 83.479445 19.107432 72.240445 37.466628 C 64.300324 51.782065 58.606249 65.562428 60.510123 77.527045 C 60.510123 77.527045 -5.950002 95.333624 -5.950002 95.333624 C -10.477187 83.544441 -23.102418 74.167479 -37.912278 65.448395 C -37.973693 65.413308 -38.026335 65.378222 -38.08775 65.343135 C -56.047338 54.913567 -70.041252 37.650834 -75.831837 16.011017 C -87.465649 -27.42651 -61.688772 -72.065761 -18.250609 -83.697053 C 25.17878 -95.328346 69.818928 -69.557051 81.45274 -26.119524 Z M 81.45274 -26.119524 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 48.558819, 96.244115)"
                fill="none"
                stroke-linejoin="round"
                d="M 10.396227 59.248597 C 5.676023 34.275528 -0.491828 9.565611 -8.07223 -14.661862 C -11.274599 -24.907224 -14.819139 -35.257846 -20.908027 -43.906756 C -23.118978 -47.04703 -26.724933 -50.231162 -29.94485 -48.652253 C -31.997875 -47.643506 -32.945426 -44.889188 -32.56816 -42.433108 C -32.190895 -39.977028 -30.743249 -37.819187 -29.049941 -36.091159 C -24.540304 -31.486009 -18.29349 -29.4422 -12.22215 -28.801865 C -5.940242 -28.135215 0.508364 -28.82818 6.193666 -31.556183 C 11.887741 -34.275414 16.757097 -39.126172 19.125973 -45.371632 C 20.213901 -48.257526 20.740318 -51.660951 19.45937 -54.546845 C 18.187196 -57.432739 14.590015 -59.248483 12.194818 -57.537999 C 11.238494 -56.853805 10.615567 -55.731026 10.168113 -54.581932 C 8.474806 -50.204846 8.983675 -45.161111 9.685564 -40.398071 C 14.572467 -7.319938 27.478453 24.117884 32.944415 57.108299 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="butt"
                transform="matrix(0.445227, 0, 0, 0.445323, 58.270559, 122.423791)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="miter"
                d="M 35.987057 -3.93403 C 35.987057 -3.93403 -33.131473 14.583057 -33.131473 14.583057 C -33.131473 14.583057 -35.982898 3.934197 -35.982898 3.934197 C -35.982898 3.934197 33.135633 -14.582891 33.135633 -14.582891 C 33.135633 -14.582891 35.987057 -3.93403 35.987057 -3.93403 Z M 35.987057 -3.93403 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="10"
              />
              <path
                stroke-linecap="butt"
                transform="matrix(0.445227, 0, 0, 0.445323, 60.697042, 131.484786)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="miter"
                d="M 35.985479 -3.93065 C 35.985479 -3.93065 -33.133051 14.577666 -33.133051 14.577666 C -33.133051 14.577666 -35.984476 3.928805 -35.984476 3.928805 C -35.984476 3.928805 33.134055 -14.579511 33.134055 -14.579511 C 33.134055 -14.579511 35.985479 -3.93065 35.985479 -3.93065 Z M 35.985479 -3.93065 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="10"
              />
              <path
                stroke-linecap="butt"
                transform="matrix(0.445227, 0, 0, 0.445323, 59.484691, 126.956754)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="miter"
                d="M 37.997813 -4.98171 C 37.997813 -4.98171 -35.402241 14.684472 -35.402241 14.684472 C -35.402241 14.684472 -37.999231 4.974185 -37.999231 4.974185 C -37.999231 4.974185 35.400823 -14.683225 35.400823 -14.683225 C 35.400823 -14.683225 37.997813 -4.98171 37.997813 -4.98171 Z M 37.997813 -4.98171 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="10"
              />
              <path
                stroke-linecap="butt"
                transform="matrix(0.445227, 0, 0, 0.445323, 61.966386, 136.226156)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="miter"
                d="M 32.072869 -2.884981 C 32.072869 -2.884981 -29.228371 13.526895 -29.228371 13.526895 C -29.228371 13.526895 -32.071022 2.886806 -32.071022 2.886806 C -32.071022 2.886806 29.221445 -13.533842 29.221445 -13.533842 C 29.221445 -13.533842 32.072869 -2.884981 32.072869 -2.884981 Z M 32.072869 -2.884981 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="10"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 217.385301, 69.289593)"
                fill-opacity="1"
                fill="#253237"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 118.973389 37.111929 C 118.973389 37.111929 -118.975795 37.111929 -118.975795 37.111929 C -118.975795 37.111929 -118.975795 -37.114312 -118.975795 -37.114312 C -118.975795 -37.114312 118.973389 -37.114312 118.973389 -37.114312 C 118.973389 -37.114312 118.973389 37.111929 118.973389 37.111929 Z M 118.973389 37.111929 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 209.7078, 199.498161)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 234.903014 297.163475 C 234.903014 297.163475 -234.906465 297.163475 -234.906465 297.163475 C -234.906465 297.163475 -234.906465 -297.163989 -234.906465 -297.163989 C -234.906465 -297.163989 234.903014 -297.163989 234.903014 -297.163989 C 234.903014 -297.163989 234.903014 297.163475 234.903014 297.163475 Z M 234.903014 297.163475 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 100.803036, 199.498161)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -9.699907 297.163475 C -9.699907 297.163475 9.698553 297.163475 9.698553 297.163475 C 9.698553 297.163475 9.698553 -297.163989 9.698553 -297.163989 C 9.698553 -297.163989 -9.699907 -297.163989 -9.699907 -297.163989 C -9.699907 -297.163989 -9.699907 297.163475 -9.699907 297.163475 Z M -9.699907 297.163475 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 211.514532, 197.542314)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 213.947031 275.722747 C 213.947031 275.722747 -213.950894 275.722747 -213.950894 275.722747 C -213.950894 275.722747 -213.950894 -275.72858 -213.950894 -275.72858 C -213.950894 -275.72858 213.947031 -275.72858 213.947031 -275.72858 C 213.947031 -275.72858 213.947031 275.722747 213.947031 275.722747 Z M 213.947031 275.722747 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 227.109934, 63.456293)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 118.96895 -24.015296 C 118.96895 -24.015296 118.96895 50.210946 118.96895 50.210946 C 118.96895 50.210946 -118.97146 50.210946 -118.97146 50.210946 C -118.97146 50.210946 -118.97146 -24.015296 -118.97146 -24.015296 C -118.97146 -24.015296 -68.145914 -24.015296 -68.145914 -24.015296 C -68.049404 -31.208101 -64.855809 -37.699169 -59.732018 -42.435894 C -54.520492 -47.242793 -47.334902 -50.216404 -39.394781 -50.216404 C -39.394781 -50.216404 39.392272 -50.216404 39.392272 -50.216404 C 55.140909 -50.216404 67.941612 -38.52371 68.143405 -24.015296 C 68.143405 -24.015296 118.96895 -24.015296 118.96895 -24.015296 Z M 118.96895 -24.015296 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 145.514072, 129.997426)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 27.649145 27.654223 C 27.649145 27.654223 -27.650943 27.654223 -27.650943 27.654223 C -27.650943 27.654223 -27.650943 -27.651432 -27.650943 -27.651432 C -27.650943 -27.651432 27.649145 -27.651432 27.649145 -27.651432 C 27.649145 -27.651432 27.649145 27.654223 27.649145 27.654223 Z M 27.649145 27.654223 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 145.514072, 168.877729)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 27.649145 27.651084 C 27.649145 27.651084 -27.650943 27.651084 -27.650943 27.651084 C -27.650943 27.651084 -27.650943 -27.654571 -27.650943 -27.654571 C -27.650943 -27.654571 27.649145 -27.654571 27.649145 -27.654571 C 27.649145 -27.654571 27.649145 27.651084 27.649145 27.651084 Z M 27.649145 27.651084 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 145.514072, 207.75758)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 27.649145 27.648963 C 27.649145 27.648963 -27.650943 27.648963 -27.650943 27.648963 C -27.650943 27.648963 -27.650943 -27.64792 -27.650943 -27.64792 C -27.650943 -27.64792 27.649145 -27.64792 27.649145 -27.64792 C 27.649145 -27.64792 27.649145 27.648963 27.649145 27.648963 Z M 27.649145 27.648963 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 145.514072, 246.63787)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 27.649145 27.654629 C 27.649145 27.654629 -27.650943 27.654629 -27.650943 27.654629 C -27.650943 27.654629 -27.650943 -27.651026 -27.650943 -27.651026 C -27.650943 -27.651026 27.649145 -27.651026 27.649145 -27.651026 C 27.649145 -27.651026 27.649145 27.654629 27.649145 27.654629 Z M 27.649145 27.654629 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 145.514072, 285.518173)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 27.649145 27.651491 C 27.649145 27.651491 -27.650943 27.651491 -27.650943 27.651491 C -27.650943 27.651491 -27.650943 -27.654164 -27.650943 -27.654164 C -27.650943 -27.654164 27.649145 -27.654164 27.649145 -27.654164 C 27.649145 -27.654164 27.649145 27.651491 27.649145 27.651491 Z M 27.649145 27.651491 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 227.299601, 125.201738)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 131.826201 3.20479 C 131.826201 3.20479 -131.829671 3.20479 -131.829671 3.20479 C -133.145713 3.20479 -134.20732 2.134641 -134.20732 0.818884 C -134.20732 0.818884 -134.20732 -0.821427 -134.20732 -0.821427 C -134.20732 -2.137184 -133.145713 -3.198561 -131.829671 -3.198561 C -131.829671 -3.198561 131.826201 -3.198561 131.826201 -3.198561 C 133.142243 -3.198561 134.212624 -2.137184 134.212624 -0.821427 C 134.212624 -0.821427 134.212624 0.818884 134.212624 0.818884 C 134.212624 2.134641 133.142243 3.20479 131.826201 3.20479 Z M 131.826201 3.20479 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 231.487403, 132.97797)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 141.230835 3.198514 C 141.230835 3.198514 -141.235666 3.198514 -141.235666 3.198514 C -142.551708 3.198514 -143.613315 2.137137 -143.613315 0.82138 C -143.613315 0.82138 -143.613315 -0.818931 -143.613315 -0.818931 C -143.613315 -2.134688 -142.551708 -3.204837 -141.235666 -3.204837 C -141.235666 -3.204837 141.230835 -3.204837 141.230835 -3.204837 C 142.546877 -3.204837 143.617258 -2.134688 143.617258 -0.818931 C 143.617258 -0.818931 143.617258 0.82138 143.617258 0.82138 C 143.617258 2.137137 142.546877 3.198514 141.230835 3.198514 Z M 141.230835 3.198514 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 227.299601, 164.989167)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 131.826201 3.199686 C 131.826201 3.199686 -131.829671 3.199686 -131.829671 3.199686 C -133.145713 3.199686 -134.20732 2.138308 -134.20732 0.81378 C -134.20732 0.81378 -134.20732 -0.817759 -134.20732 -0.817759 C -134.20732 -2.133516 -133.145713 -3.203665 -131.829671 -3.203665 C -131.829671 -3.203665 131.826201 -3.203665 131.826201 -3.203665 C 133.142243 -3.203665 134.212624 -2.133516 134.212624 -0.817759 C 134.212624 -0.817759 134.212624 0.81378 134.212624 0.81378 C 134.212624 2.138308 133.142243 3.199686 131.826201 3.199686 Z M 131.826201 3.199686 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 225.162953, 172.765853)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 127.026875 3.201164 C 127.026875 3.201164 -127.030663 3.201164 -127.030663 3.201164 C -128.346705 3.201164 -129.408313 2.131015 -129.408313 0.815258 C -129.408313 0.815258 -129.408313 -0.816281 -129.408313 -0.816281 C -129.408313 -2.132038 -128.346705 -3.202187 -127.030663 -3.202187 C -127.030663 -3.202187 127.026875 -3.202187 127.026875 -3.202187 C 128.342918 -3.202187 129.413298 -2.132038 129.413298 -0.816281 C 129.413298 -0.816281 129.413298 0.815258 129.413298 0.815258 C 129.413298 2.131015 128.342918 3.201164 127.026875 3.201164 Z M 127.026875 3.201164 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 227.299601, 203.869457)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 131.826201 3.205351 C 131.826201 3.205351 -131.829671 3.205351 -131.829671 3.205351 C -133.145713 3.205351 -134.20732 2.135202 -134.20732 0.819445 C -134.20732 0.819445 -134.20732 -0.820865 -134.20732 -0.820865 C -134.20732 -2.136622 -133.145713 -3.198 -131.829671 -3.198 C -131.829671 -3.198 131.826201 -3.198 131.826201 -3.198 C 133.142243 -3.198 134.212624 -2.136622 134.212624 -0.820865 C 134.212624 -0.820865 134.212624 0.819445 134.212624 0.819445 C 134.212624 2.135202 133.142243 3.205351 131.826201 3.205351 Z M 131.826201 3.205351 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 231.487403, 211.646159)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 141.230835 3.19802 C 141.230835 3.19802 -141.235666 3.19802 -141.235666 3.19802 C -142.551708 3.19802 -143.613315 2.136643 -143.613315 0.820886 C -143.613315 0.820886 -143.613315 -0.819425 -143.613315 -0.819425 C -143.613315 -2.135182 -142.551708 -3.205331 -141.235666 -3.205331 C -141.235666 -3.205331 141.230835 -3.205331 141.230835 -3.205331 C 142.546877 -3.205331 143.617258 -2.135182 143.617258 -0.819425 C 143.617258 -0.819425 143.617258 0.820886 143.617258 0.820886 C 143.617258 2.136643 142.546877 3.19802 141.230835 3.19802 Z M 141.230835 3.19802 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 230.159294, 242.749761)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 138.247771 3.202213 C 138.247771 3.202213 -138.252672 3.202213 -138.252672 3.202213 C -139.568714 3.202213 -140.630322 2.132064 -140.630322 0.816307 C -140.630322 0.816307 -140.630322 -0.815232 -140.630322 -0.815232 C -140.630322 -2.130989 -139.568714 -3.201138 -138.252672 -3.201138 C -138.252672 -3.201138 138.247771 -3.201138 138.247771 -3.201138 C 139.563813 -3.201138 140.634194 -2.130989 140.634194 -0.815232 C 140.634194 -0.815232 140.634194 0.816307 140.634194 0.816307 C 140.634194 2.132064 139.563813 3.202213 138.247771 3.202213 Z M 138.247771 3.202213 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 226.972348, 250.526448)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 131.096032 3.203686 C 131.096032 3.203686 -131.094646 3.203686 -131.094646 3.203686 C -132.410689 3.203686 -133.472296 2.133537 -133.472296 0.81778 C -133.472296 0.81778 -133.472296 -0.813759 -133.472296 -0.813759 C -133.472296 -2.138288 -132.410689 -3.199665 -131.094646 -3.199665 C -131.094646 -3.199665 131.096032 -3.199665 131.096032 -3.199665 C 132.412075 -3.199665 133.473682 -2.138288 133.473682 -0.813759 C 133.473682 -0.813759 133.473682 0.81778 133.473682 0.81778 C 133.473682 2.133537 132.412075 3.203686 131.096032 3.203686 Z M 131.096032 3.203686 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 227.299601, 281.630064)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 131.826201 3.199075 C 131.826201 3.199075 -131.829671 3.199075 -131.829671 3.199075 C -133.145713 3.199075 -134.20732 2.137697 -134.20732 0.82194 C -134.20732 0.82194 -134.20732 -0.81837 -134.20732 -0.81837 C -134.20732 -2.134127 -133.145713 -3.204276 -131.829671 -3.204276 C -131.829671 -3.204276 131.826201 -3.204276 131.826201 -3.204276 C 133.142243 -3.204276 134.212624 -2.134127 134.212624 -0.81837 C 134.212624 -0.81837 134.212624 0.82194 134.212624 0.82194 C 134.212624 2.137697 133.142243 3.199075 131.826201 3.199075 Z M 131.826201 3.199075 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 231.487403, 289.406282)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 141.230835 3.201603 C 141.230835 3.201603 -141.235666 3.201603 -141.235666 3.201603 C -142.551708 3.201603 -143.613315 2.131454 -143.613315 0.815697 C -143.613315 0.815697 -143.613315 -0.815842 -143.613315 -0.815842 C -143.613315 -2.131599 -142.551708 -3.201748 -141.235666 -3.201748 C -141.235666 -3.201748 141.230835 -3.201748 141.230835 -3.201748 C 142.546877 -3.201748 143.617258 -2.131599 143.617258 -0.815842 C 143.617258 -0.815842 143.617258 0.815697 143.617258 0.815697 C 143.617258 2.131454 142.546877 3.201603 141.230835 3.201603 Z M 141.230835 3.201603 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 319.848799, 127.271763)"
                fill-opacity="1"
                fill="#253237"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 13.228042 -55.240494 C -15.645921 -75.704902 -52.20557 -41.837315 -47.037912 -6.987296 C -54.556899 11.950834 -51.065001 31.976656 -42.010631 52.546325 C -17.233945 66.089851 39.970018 75.703649 54.560538 30.406519 C 51.428357 5.556254 48.208441 -18.416839 44.093616 -33.679621 C 40.750869 -48.942403 28.845075 -54.24929 13.228042 -55.240494 Z M 13.228042 -55.240494 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 319.848799, 127.271763)"
                fill-opacity="1"
                fill="#253237"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 13.228042 -55.240494 C -15.645921 -75.704902 -52.20557 -41.837315 -47.037912 -6.987296 C -54.556899 11.950834 -51.065001 31.976656 -42.010631 52.546325 C -17.233945 66.089851 39.970018 75.703649 54.560538 30.406519 C 51.428357 5.556254 48.208441 -18.416839 44.093616 -33.679621 C 40.750869 -48.942403 28.845075 -54.24929 13.228042 -55.240494 Z M 13.228042 -55.240494 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="butt"
                transform="matrix(0.445227, 0, 0, 0.445323, 349.632077, 202.161223)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="miter"
                d="M -6.859313 26.505724 C -4.481664 45.68069 16.952275 43.022861 14.574625 23.856666 C 14.574625 23.856666 7.485545 -45.676708 7.485545 -45.676708 C 7.485545 -45.676708 -16.948969 -34.247165 -16.948969 -34.247165 C -16.948969 -34.247165 -6.859313 26.505724 -6.859313 26.505724 Z M -6.859313 26.505724 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="10"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 348.712722, 176.016277)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 0.38203 -33.518183 C 10.033005 -18.76416 15.885006 0.366947 18.701336 22.989197 C 18.701336 22.989197 -16.752838 33.524025 -16.752838 33.524025 C -16.752838 33.524025 -18.70058 5.945757 -18.70058 5.945757 C -18.270673 -15.825636 -14.20849 -32.32523 0.38203 -33.518183 Z M 0.38203 -33.518183 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 378.801163, 187.654814)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -19.592338 10.687172 C -17.074311 3.582083 -13.152505 -3.452831 -8.581453 -10.452658 C -7.9673 -11.400004 -7.168901 -12.242088 -6.203803 -12.829793 C -4.6421 -13.768366 -3.352379 -13.663106 -2.290771 -12.680674 C -0.737842 -11.259656 -0.500954 -8.891293 -1.492372 -7.040462 C -1.492372 -7.040462 -6.151161 1.582133 -6.151161 1.582133 C -3.203227 -0.338873 -0.571143 -2.584431 1.824054 -5.075598 C 4.903592 -8.286045 6.807466 -12.382436 7.281241 -16.461282 C 7.368978 -17.180563 7.44794 -17.8823 7.526903 -18.575265 C 7.869074 -21.487474 11.167952 -23.127785 13.624564 -21.522561 C 14.607209 -20.882226 15.502118 -20.03137 16.300517 -18.978764 C 19.055431 -15.347275 19.590622 -10.478974 18.046466 -6.189606 C 16.054855 -0.628339 12.677014 4.924156 6.974165 10.450335 C 6.974165 10.450335 -8.335791 23.134233 -8.335791 23.134233 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                fill="#d4d4d4"
                d="M 349.054688 211.816406 C 344.03125 215.816406 350.085938 223.417969 355.109375 219.417969 C 355.109375 219.417969 375.089844 197.957031 375.089844 197.957031 C 375.089844 197.957031 370.078125 192.414062 370.078125 192.414062 C 370.078125 192.414062 349.054688 211.816406 349.054688 211.816406 Z M 349.054688 211.816406 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 362.75069, 199.175762)"
                fill="none"
                stroke-linejoin="round"
                d="M -16.460849 15.18388 C -16.460849 15.18388 16.45775 -15.183793 16.45775 -15.183793 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 360.99253, 209.926324)"
                fill="none"
                stroke-linejoin="round"
                d="M -31.655968 12.612505 C -29.848603 22.498226 -20.627535 26.884083 -13.213831 21.314045 C -13.213831 21.314045 31.663204 -26.87775 31.663204 -26.87775 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 311.66083, 323.115707)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -6.95899 57.76506 C -5.844741 55.56336 -3.326714 54.326549 0.0686749 42.888234 C 2.893779 33.379696 -7.774936 -16.91731 -11.819572 -43.89033 C -13.977881 -56.126871 -11.889761 -70.547568 -11.126456 -75.450956 C -1.256141 -74.968512 6.192657 -75.126403 16.071747 -75.450956 C 16.264766 -71.415968 16.984203 -59.381177 17.168448 -55.390047 C 17.291279 -52.688359 17.361468 -50.03053 17.431657 -47.381472 C 17.431657 -47.381472 17.449204 -47.381472 17.449204 -47.381472 C 17.449204 -47.381472 19.40572 -19.37339 16.071747 4.731279 C 11.149749 40.274263 15.975237 49.62491 16.159483 50.256473 C 16.159483 50.256473 14.589006 59.124676 10.86022 59.931674 C 0.586318 62.150917 -5.414834 75.457607 -11.819572 74.106763 C -18.22431 72.764691 -19.399974 70.992805 -19.399974 70.992805 C -19.399974 70.992805 -9.424375 62.642133 -6.95899 57.76506 Z M -6.95899 57.76506 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 308.722329, 353.726817)"
                fill-opacity="1"
                fill="#253237"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -9.685334 4.095818 C -12.799967 3.762493 -4.447486 -5.430263 -5.017771 -5.026764 C -5.588056 -4.623265 -24.389911 10.797408 -25.670858 14.297321 C -26.144633 15.577992 -25.188309 17.946354 -21.415655 18.218277 C -17.643001 18.481429 -5.237111 14.59556 -1.675024 13.279803 C 1.887063 11.955274 14.178896 -4.465374 16.819754 -5.719729 C 19.451838 -6.965313 19.855424 9.858834 20.45203 10.04304 C 20.45203 10.04304 22.513829 8.569392 22.513829 8.569392 C 22.513829 8.569392 26.146106 -8.807373 22.759491 -18.482573 C 22.759491 -18.482573 19.995802 -17.95627 13.591064 -11.324854 C 6.773966 -4.263625 -5.351168 4.569491 -9.685334 4.095818 Z M -9.685334 4.095818 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="butt"
                transform="matrix(0.445227, 0, 0, 0.445323, 293.971509, 201.066362)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="miter"
                d="M 2.538151 27.613454 C -3.427906 45.990194 -23.97571 39.306148 -18.000879 20.93818 C -18.000879 20.93818 2.152112 -45.989996 2.152112 -45.989996 C 2.152112 -45.989996 23.97209 -30.121966 23.97209 -30.121966 C 23.97209 -30.121966 2.538151 27.613454 2.538151 27.613454 Z M 2.538151 27.613454 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="10"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 299.807551, 176.388766)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 6.872082 -34.538833 C -5.402203 -21.88125 -14.772423 -4.206247 -21.835182 17.477429 C -21.835182 17.477429 10.978134 34.538412 10.978134 34.538412 C 10.978134 34.538412 18.119856 7.828544 18.119856 7.828544 C 21.831094 -13.627068 20.980054 -30.600334 6.872082 -34.538833 Z M 6.872082 -34.538833 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 331.055821, 352.303985)"
                fill-opacity="1"
                fill="#253237"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -7.653137 -28.120536 C -7.653137 -28.120536 -11.873245 -23.155746 -11.101167 -16.72608 C -10.329089 -10.287642 -9.513143 -2.279067 -10.644939 2.8787 C -11.785509 8.027696 -10.188711 18.702872 -3.073311 23.413282 C 4.033317 28.123692 9.692298 25.018506 10.780226 18.28183 C 11.876928 11.545153 7.183044 0.475251 7.183044 0.475251 C 7.183044 0.475251 -7.653137 -28.120536 -7.653137 -28.120536 Z M -7.653137 -28.120536 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 331.17423, 318.316024)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 10.049273 -10.498882 C 6.627563 16.675887 0.25792 44.48222 5.802844 71.937684 C 6.285392 74.349905 6.864451 76.797213 6.61879 79.244521 C 6.373129 81.691829 5.109728 84.20054 2.916325 85.130341 C 0.626411 86.09523 -2.110956 85.060167 -3.821811 83.209336 C -5.532666 81.349733 -6.401253 78.832251 -7.02418 76.349856 C -10.402021 62.780015 -7.524276 48.482121 -7.55937 34.464923 C -7.620786 14.395242 -12.832312 -4.788496 -14.797602 -24.603798 C -16.762891 -44.471729 -15.385434 -64.883507 -14.464205 -84.777754 C -5.515118 -85.225111 3.679629 -86.093511 12.549753 -84.812841 C 12.549753 -84.812841 15.620518 -68.234302 15.831084 -66.401014 C 16.550521 -60.366074 16.761087 -54.25219 16.410143 -48.182164 C 15.664386 -35.480723 11.637297 -23.103835 10.049273 -10.498882 Z M 10.049273 -10.498882 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 322.986083, 260.741026)"
                fill-opacity="1"
                fill="#253237"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -36.28273 -101.170339 C -36.28273 -101.170339 35.037977 -102.573813 35.037977 -102.573813 C 60.297212 -65.986995 49.049439 15.712747 39.731861 95.044126 C 12.542431 102.570256 -14.69964 101.947464 -42.003127 93.289783 C -53.505335 15.572399 -60.296112 -57.61878 -36.28273 -101.170339 Z M -36.28273 -101.170339 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 324.449525, 186.900185)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -48.527547 -57.958637 C -38.595817 -63.993576 -28.260499 -67.958391 -17.275935 -68.651356 C -17.275935 -68.651356 -8.151376 -59.695437 -8.151376 -59.695437 C -8.151376 -59.695437 15.493513 -74.65998 15.493513 -74.65998 C 15.493513 -74.65998 54.878266 -57.958637 54.878266 -57.958637 C 41.384448 -17.284201 33.461875 23.127084 31.75102 63.240131 C 7.974526 74.660903 -15.801968 74.073198 -39.569688 64.643606 C -37.446473 41.749433 -36.656848 21.478002 -41.113844 11.451933 C -53.256525 2.662676 -54.879644 -14.100069 -45.834048 -38.93279 C -45.430462 -44.029156 -46.685089 -50.713202 -48.527547 -57.958637 Z M -48.527547 -57.958637 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 324.052841, 148.630868)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -16.384963 -10.355027 C -16.384963 -10.355027 -16.384963 17.284643 -16.384963 17.284643 C -16.384963 17.284643 -7.260405 26.240563 -7.260405 26.240563 C -7.260405 26.240563 16.384485 11.27602 16.384485 11.27602 C 16.384485 11.27602 16.156371 -26.2406 16.156371 -26.2406 C 16.156371 -26.2406 -16.384963 -10.355027 -16.384963 -10.355027 Z M -16.384963 -10.355027 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 324.052841, 148.630868)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -16.384963 -10.355027 C -16.384963 -10.355027 -16.384963 17.284643 -16.384963 17.284643 C -16.384963 17.284643 -7.260405 26.240563 -7.260405 26.240563 C -7.260405 26.240563 16.384485 11.27602 16.384485 11.27602 C 16.384485 11.27602 16.156371 -26.2406 16.156371 -26.2406 C 16.156371 -26.2406 -16.384963 -10.355027 -16.384963 -10.355027 Z M -16.384963 -10.355027 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 323.868076, 143.682875)"
                fill-opacity="1"
                fill="#253237"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -15.969972 3.027855 C -15.969972 3.027855 -15.671669 12.176752 -15.671669 12.176752 C -2.169077 12.396045 9.877095 2.676986 15.965983 -12.594567 C 6.736141 -4.252667 -5.608334 2.554182 -15.969972 3.027855 Z M -15.969972 3.027855 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 316.38201, 158.746391)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 0.84407 -9.368858 C -7.596146 -5.886488 -9.965022 -1.921674 -8.157658 2.5519 C -7.043409 5.288675 -4.69208 7.314941 -1.928392 8.07808 C 2.730397 9.367522 6.538146 7.20968 9.968629 3.525561 C 9.968629 3.525561 0.84407 -5.430359 0.84407 -5.430359 C 0.84407 -5.430359 0.84407 -9.368858 0.84407 -9.368858 Z M 0.84407 -9.368858 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 328.155618, 158.277907)"
                fill-opacity="1"
                fill="#02c37e"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -16.475428 4.57757 C -16.475428 4.57757 7.169462 -10.386974 7.169462 -10.386974 C 7.169462 -10.386974 7.169462 -13.421987 7.169462 -13.421987 C 16.478266 -5.702879 16.162416 1.674133 6.757102 8.717819 C -3.990575 13.419457 -11.237581 11.033551 -16.475428 4.57757 Z M -16.475428 4.57757 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 318.836551, 192.924971)"
                fill="none"
                stroke-linejoin="round"
                d="M -23.093529 -1.805153 C -16.627376 0.379003 -9.6699 -1.357796 -3.080916 -3.077052 C -1.922799 -3.384062 -0.738361 -3.6823 0.446077 -3.533181 C 2.113064 -3.313888 3.551936 -2.243739 5.01713 -1.349024 C 10.491865 1.966683 16.879056 2.852627 23.090775 3.685939 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.437047, -0.0849717, 0.0849533, 0.437142, 336.756834, 211.174834)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -172.284555 91.186986 C -172.284555 91.186986 128.869627 -147.562714 128.869627 -147.562714 C 128.869627 -147.562714 172.284236 -93.461368 172.284236 -93.461368 C 172.284236 -93.461368 -130.526613 147.557716 -130.526613 147.557716 C -130.526613 147.557716 -172.284555 91.186986 -172.284555 91.186986 Z M -172.284555 91.186986 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.437047, -0.0849717, 0.0849533, 0.437142, 274.507322, 280.713869)"
                fill-opacity="1"
                fill="#ffffff"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -36.84177 35.411497 C -36.84177 35.411497 -7.255207 -30.905415 -7.255207 -30.905415 C -7.255207 -30.905415 -5.244231 -35.411388 -5.244231 -35.411388 C -5.244231 -35.411388 4.487834 -33.197975 4.487834 -33.197975 C 4.487834 -33.197975 5.4045 -24.441338 5.4045 -24.441338 C 5.4045 -24.441338 12.090628 -22.927225 12.090628 -22.927225 C 12.090628 -22.927225 13.057637 -13.142111 13.057637 -13.142111 C 13.057637 -13.142111 20.346846 -11.787784 20.346846 -11.787784 C 20.346846 -11.787784 20.710775 -1.842884 20.710775 -1.842884 C 20.710775 -1.842884 28.714083 -0.483788 28.714083 -0.483788 C 28.714083 -0.483788 28.168766 7.747399 28.168766 7.747399 C 28.168766 7.747399 36.836792 10.468856 36.836792 10.468856 C 36.836792 10.468856 36.515384 20.950731 36.515384 20.950731 C 36.515384 20.950731 -36.84177 35.411497 -36.84177 35.411497 Z M -36.84177 35.411497 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.437047, -0.0849717, 0.0849533, 0.437142, 327.772277, 210.292682)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 118.704256 -93.976803 C 118.704256 -93.976803 117.992219 -94.865824 117.992219 -94.865824 C 117.992219 -94.865824 -118.701447 94.863316 -118.701447 94.863316 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.437047, -0.0849717, 0.0849533, 0.437142, 337.538121, 219.232782)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 118.87309 -93.744408 C 118.87309 -93.744408 118.161054 -94.633429 118.161054 -94.633429 C 118.161054 -94.633429 -118.872365 94.636491 -118.872365 94.636491 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.437047, -0.0849717, 0.0849533, 0.437142, 264.650456, 295.059577)"
                fill-opacity="1"
                fill="#253237"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -1.806244 -8.020341 C -1.806244 -8.020341 8.964411 4.483575 8.964411 4.483575 C 8.964411 4.483575 -8.964488 8.02216 -8.964488 8.02216 C -8.964488 8.02216 -1.806244 -8.020341 -1.806244 -8.020341 Z M -1.806244 -8.020341 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.437047, -0.0849717, 0.0849533, 0.437142, 381.137293, 180.473066)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 11.573036 -0.137249 C 11.573036 -0.137249 6.437163 -10.500375 6.437163 -10.500375 C 5.528615 -12.401606 3.698183 -13.284623 1.759625 -14.117171 C -1.422502 -15.495265 -4.161785 -14.231613 -6.578863 -10.993051 C -9.023208 -7.706174 -10.205541 -3.646768 -10.207274 0.454468 C -10.207274 0.454468 -10.209561 15.502064 -10.209561 15.502064 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.42097, 0.144983, -0.144952, 0.421062, 321.062493, 238.759143)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -18.475396 -14.042016 C -10.83964 -14.58386 -2.696911 -13.788094 5.679448 -12.36771 C 6.813359 -12.173686 7.924285 -11.776929 8.860321 -11.106577 C 10.369022 -10.039673 10.797391 -8.7956 10.311611 -7.403749 C 9.615581 -5.382875 7.510259 -4.194097 5.385909 -4.381062 C 5.385909 -4.381062 -4.544043 -5.220115 -4.544043 -5.220115 C -1.553159 -3.244164 1.602689 -1.705377 4.896845 -0.492528 C 9.132343 1.0827 13.7281 1.197971 17.717066 -0.0178281 C 18.422465 -0.232885 19.111272 -0.442229 19.783489 -0.64586 C 22.641123 -1.50922 25.508522 0.889614 25.010219 3.83506 C 24.813698 5.015985 24.37579 6.196532 23.726821 7.356982 C 21.455291 11.404688 17.145643 13.871996 12.52078 14.184218 C 6.523336 14.579417 -0.011135 13.684463 -7.479726 10.615601 C -7.479726 10.615601 -25.51481 1.490456 -25.51481 1.490456 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                fill="#d4d4d4"
                d="M 293.976562 210.421875 C 289.519531 205.652344 282.308594 212.394531 286.765625 217.164062 C 286.765625 217.164062 310.105469 235.6875 310.105469 235.6875 C 310.105469 235.6875 315.320312 230.167969 315.320312 230.167969 C 315.320312 230.167969 293.976562 210.421875 293.976562 210.421875 Z M 293.976562 210.421875 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.42097, 0.144983, -0.144952, 0.421062, 305.637857, 221.209783)"
                fill="none"
                stroke-linejoin="round"
                d="M -27.106435 -11.936261 C -27.106435 -11.936261 27.111585 11.939969 27.111585 11.939969 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.42097, 0.144983, -0.144952, 0.421062, 298.254783, 221.346945)"
                fill="none"
                stroke-linejoin="round"
                d="M -34.176597 -16.275178 C -34.055899 -8.486826 -35.651536 -5.117151 -27.465594 -0.476972 C -27.465594 -0.476972 35.651162 21.782412 35.651162 21.782412 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                fill="#253237"
                d="M 329.671875 137.097656 C 329.671875 137.097656 316.523438 140.601562 316.523438 140.601562 C 316.523438 140.601562 316.261719 147.351562 316.261719 147.351562 C 316.261719 147.351562 325.378906 144.285156 325.378906 144.285156 C 325.378906 144.285156 330.109375 138.9375 330.109375 138.9375 C 330.109375 138.9375 329.671875 137.097656 329.671875 137.097656 Z M 329.671875 137.097656 "
                fill-opacity="1"
                fill-rule="nonzero"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 315.499404, 127.34213)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -26.986297 -20.785323 C -36.619725 41.055258 4.247768 54.844392 35.271267 23.590776 C 35.271267 23.590776 36.622404 -4.890978 36.622404 -4.890978 C 36.622404 -4.890978 36.622404 -23.855423 36.622404 -23.855423 C 24.155098 -54.845888 -20.046369 -47.363616 -26.986297 -20.785323 Z M -26.986297 -20.785323 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 334.446041, 128.434505)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -5.9326 -7.34397 C 1.463557 -11.914033 5.780175 -11.142122 6.5698 -4.238784 C 6.824235 -2.063399 6.596121 0.147073 6.052157 2.269828 C 3.683281 11.506442 -1.440509 11.918713 -6.818735 11.506442 C -6.818735 11.506442 -5.9326 -7.34397 -5.9326 -7.34397 Z M -5.9326 -7.34397 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 317.731317, 113.190631)"
                fill-opacity="1"
                fill="#253237"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 8.99105 -7.840172 C 8.912087 10.08044 17.396172 21.755591 31.609427 29.229091 C 31.609427 29.229091 35.662836 -7.840172 35.662836 -7.840172 C -1.809269 -29.22561 -19.128383 -15.804888 -35.657871 -1.02455 C -35.657871 -1.02455 -31.999274 10.992698 -31.999274 10.992698 C -17.005168 9.396246 -2.984933 4.361282 8.99105 -7.840172 Z M 8.99105 -7.840172 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 315.499404, 127.34213)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -26.986297 -20.785323 C -36.619725 41.055258 4.247768 54.844392 35.271267 23.590776 C 35.271267 23.590776 36.622404 -4.890978 36.622404 -4.890978 C 36.622404 -4.890978 36.622404 -23.855423 36.622404 -23.855423 C 24.155098 -54.845888 -20.046369 -47.363616 -26.986297 -20.785323 Z M -26.986297 -20.785323 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 334.446041, 128.434505)"
                fill-opacity="1"
                fill="#d4d4d4"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -5.9326 -7.34397 C 1.463557 -11.914033 5.780175 -11.142122 6.5698 -4.238784 C 6.824235 -2.063399 6.596121 0.147073 6.052157 2.269828 C 3.683281 11.506442 -1.440509 11.918713 -6.818735 11.506442 C -6.818735 11.506442 -5.9326 -7.34397 -5.9326 -7.34397 Z M -5.9326 -7.34397 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 317.731317, 113.190631)"
                fill-opacity="1"
                fill="#253237"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 8.99105 -7.840172 C 8.912087 10.08044 17.396172 21.755591 31.609427 29.229091 C 31.609427 29.229091 35.662836 -7.840172 35.662836 -7.840172 C -1.809269 -29.22561 -19.128383 -15.804888 -35.657871 -1.02455 C -35.657871 -1.02455 -31.999274 10.992698 -31.999274 10.992698 C -17.005168 9.396246 -2.984933 4.361282 8.99105 -7.840172 Z M 8.99105 -7.840172 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 312.023954, 127.741139)"
                fill="none"
                stroke-linejoin="round"
                d="M 0.963937 -12.567512 C 0.288369 -1.673043 -1.396165 5.721511 -3.852777 10.370519 C -2.352489 12.335383 0.577898 12.563448 3.859229 12.379242 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 321.185379, 120.426685)"
                fill="none"
                stroke-linejoin="round"
                d="M -6.013936 -1.589709 C -1.039296 -2.019523 2.785999 -0.493245 6.014689 2.024237 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 307.485755, 119.822836)"
                fill="none"
                stroke-linejoin="round"
                d="M -4.477642 1.538154 C -1.494613 -0.768807 1.497189 -1.531946 4.480218 -0.768807 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 319.161376, 125.54836)"
                fill-opacity="1"
                fill="#253237"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 1.927456 -0.00333399 C 1.927456 2.136964 1.067642 3.873763 -0.00273857 3.873763 C -1.064346 3.873763 -1.92416 2.136964 -1.92416 -0.00333399 C -1.92416 -2.13486 -1.064346 -3.87166 -0.00273857 -3.87166 C 1.067642 -3.87166 1.927456 -2.13486 1.927456 -0.00333399 Z M 1.927456 -0.00333399 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 320.447193, 124.238217)"
                fill-opacity="1"
                fill="#253237"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -2.890742 -0.929658 C -0.679791 -0.833169 1.224083 -1.219124 2.89107 -2.026122 C 2.469936 -0.280551 0.890686 0.947489 -1.013188 2.02641 C -1.013188 2.02641 -2.890742 -0.929658 -2.890742 -0.929658 Z M -2.890742 -0.929658 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 308.344164, 125.137778)"
                fill-opacity="1"
                fill="#253237"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M -1.931126 -0.00237926 C -1.931126 2.137919 -1.062538 3.874718 -0.000930711 3.874718 C 1.060677 3.874718 1.929264 2.137919 1.929264 -0.00237926 C 1.929264 -2.142677 1.060677 -3.870705 -0.000930711 -3.870705 C -1.062538 -3.870705 -1.931126 -2.142677 -1.931126 -0.00237926 Z M -1.931126 -0.00237926 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 307.058788, 123.82718)"
                fill-opacity="1"
                fill="#253237"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 2.886082 -0.92768 C 0.683905 -0.831192 -1.228743 -1.225919 -2.886956 -2.024145 C -2.465823 -0.278574 -0.895346 0.949466 1.017302 2.019615 C 1.017302 2.019615 2.886082 -0.92768 2.886082 -0.92768 Z M 2.886082 -0.92768 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
              <path
                stroke-linecap="round"
                transform="matrix(0.445227, 0, 0, 0.445323, 318.504233, 136.942855)"
                fill-opacity="1"
                fill="#253237"
                fill-rule="nonzero"
                stroke-linejoin="round"
                d="M 9.422127 -4.213676 C 9.904675 -2.520735 6.895326 2.944042 1.692573 4.41769 C -3.51018 5.90011 -8.941047 2.821239 -9.423596 1.137069 C -9.897371 -0.5471 -5.343866 -0.564643 -0.141113 -2.047063 C 5.06164 -3.520711 8.939578 -5.897845 9.422127 -4.213676 Z M 9.422127 -4.213676 "
                stroke="#253237"
                stroke-width="2"
                stroke-opacity="1"
                stroke-miterlimit="4"
              />
            </svg>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
